import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from '../i18n/messages';
import { messages as researchRepositoryMessages } from '../i18n/research-repository-messages';

import { tagBackgroundColors, tagBorderColors, templateStyles } from './styles';

const ResearchRepository: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={348} height={142} fill="none">
      <rect width={336} height={142} fill={templateStyles['background']} rx={3} />
      <path
        fill={templateStyles['background']}
        d="M0 3a3 3 0 0 1 3-3h45v142.01H3a3 3 0 0 1-3-3V3Z"
      />
      <mask id="researchRepository-a" fill={templateStyles['background']}>
        <path d="M0 3a3 3 0 0 1 3-3h45v16H0V3Z" />
      </mask>
      <path fill={templateStyles['background']} d="M0 3a3 3 0 0 1 3-3h45v16H0V3Z" />
      <path
        fill="#DDE0E5"
        d="M48 0h.31v-.31H48V0Zm0 16v.31h.31V16H48ZM0 16h-.31v.31H0V16ZM3 0v.31h45v-.62H3V0Zm45 0h-.31v16h.62V0H48Zm0 16v-.31H0v.62h48V16ZM0 16h.31V3h-.62v13H0ZM3 0v-.31A3.31 3.31 0 0 0-.31 3h.62C.31 1.51 1.51.31 3 .31V0Z"
        mask="url(#researchRepository-a)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M9.64 6.6H5.3v-.47h4.35v.47Zm0 1.63H5.3v-.46h4.35v.46ZM7.47 9.87H5.29V9.4h2.18v.47Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={12.44} y={9.55}>
          {formatMessage(researchRepositoryMessages['research-repository.field-1-name'])}
        </tspan>
      </text>
      <mask id="researchRepository-b" fill={templateStyles['background']}>
        <path d="M0 16h48v18.67H0V16Z" />
      </mask>
      <path fill={templateStyles['background']} d="M0 16h48v18.67H0V16Z" />
      <path
        fill="#DDE0E5"
        d="M48 34.67v.31h.31v-.31H48Zm-48 0h-.31v.31H0v-.31ZM48 16h-.31v18.67h.62V16H48Zm0 18.67v-.31H0v.62h48v-.31Zm-48 0h.31V16H-.3v18.67H0Z"
        mask="url(#researchRepository-b)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={3.73} y={23.15}>
          {formatMessage(
            researchRepositoryMessages['research-repository.entry-1-cell-1']
          )}
        </tspan>
      </text>
      <mask id="researchRepository-c" fill={templateStyles['background']}>
        <path d="M0 34.67h48v18.67H0V34.67Z" />
      </mask>
      <path fill={templateStyles['background']} d="M0 34.67h48v18.67H0V34.67Z" />
      <path
        fill="#DDE0E5"
        d="M48 53.34v.31h.31v-.31H48Zm-48 0h-.31v.31H0v-.31Zm48-18.67h-.31v18.67h.62V34.67H48Zm0 18.67v-.31H0v.62h48v-.31Zm-48 0h.31V34.67H-.3v18.67H0Z"
        mask="url(#researchRepository-c)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={3.73} y={41.82}>
          {formatMessage(
            researchRepositoryMessages['research-repository.entry-2-cell-1']
          )}
        </tspan>
      </text>
      <mask id="researchRepository-d" fill={templateStyles['background']}>
        <path d="M0 53.34h48v31.11H0V53.34Z" />
      </mask>
      <path fill={templateStyles['background']} d="M0 53.34h48v31.11H0V53.34Z" />
      <path
        fill="#DDE0E5"
        d="M48 84.45v.31h.31v-.31H48Zm-48 0h-.31v.31H0v-.31Zm48-31.11h-.31v31.11h.62V53.34H48Zm0 31.11v-.31H0v.62h48v-.31Zm-48 0h.31V53.34H-.3v31.11H0Z"
        mask="url(#researchRepository-d)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={3.73} y={60.49}>
          {formatMessage(
            researchRepositoryMessages['research-repository.entry-3-cell-1']
          )}
        </tspan>
      </text>
      <mask id="researchRepository-e" fill={templateStyles['background']}>
        <path d="M0 84.45h48v24.89H0V84.45Z" />
      </mask>
      <path fill={templateStyles['background']} d="M0 84.45h48v24.89H0V84.45Z" />
      <path
        fill="#DDE0E5"
        d="M48 109.34v.31h.31v-.31H48Zm-48 0h-.31v.31H0v-.31Zm48-24.89h-.31v24.89h.62V84.45H48Zm0 24.89v-.31H0v.62h48v-.31Zm-48 0h.31V84.45H-.3v24.89H0Z"
        mask="url(#researchRepository-e)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={3.73} y={91.6}>
          {formatMessage(
            researchRepositoryMessages['research-repository.entry-4-cell-1']
          )}
        </tspan>
      </text>
      <mask id="researchRepository-f" fill={templateStyles['background']}>
        <path d="M0 109.34h48v18.67H0v-18.67Z" />
      </mask>
      <path fill={templateStyles['background']} d="M0 109.34h48v18.67H0v-18.67Z" />
      <path
        fill="#DDE0E5"
        d="M48 128.01v.31h.31v-.31H48Zm-48 0h-.31v.31H0v-.31Zm48-18.67h-.31v18.67h.62v-18.67H48Zm0 18.67v-.31H0v.62h48v-.31Zm-48 0h.31v-18.67H-.3v18.67H0Z"
        mask="url(#researchRepository-f)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={3.73} y={116.49}>
          {formatMessage(
            researchRepositoryMessages['research-repository.entry-5-cell-1']
          )}
        </tspan>
      </text>
      <mask id="researchRepository-g" fill={templateStyles['background']}>
        <path d="M0 128.01h336v11a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-11Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M0 128.01h336H0Zm336.31 11a3.31 3.31 0 0 1-3.31 3.31H3a3.31 3.31 0 0 1-3.31-3.31H.3c0 1.49 1.2 2.69 2.69 2.69h330c1.49 0 2.69-1.2 2.69-2.69h.62ZM3 142.32a3.31 3.31 0 0 1-3.31-3.31v-11H.3v11c0 1.49 1.2 2.69 2.69 2.69v.62Zm333.31-14.31v11a3.31 3.31 0 0 1-3.31 3.31v-.62c1.49 0 2.69-1.2 2.69-2.69v-11h.62Z"
        mask="url(#researchRepository-g)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M6.57 133.7a.26.26 0 0 0-.52 0v1.05H4.99a.26.26 0 0 0 0 .52h1.06v1.05a.26.26 0 0 0 .52 0v-1.05h1.05a.26.26 0 0 0 0-.52H6.57v-1.05Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={3.68}
        letterSpacing={-0.02}
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={10.51} y={136.32}>
          {formatMessage(messages['templates-preview.add-entry'])}
        </tspan>
      </text>
      <path fill={templateStyles['background']} d="M48 0h48v128H48z" />
      <mask id="researchRepository-h" fill={templateStyles['background']}>
        <path d="M48 0h48v16H48V0Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M96 0h.31v-.31H96V0Zm0 16v.31h.31V16H96ZM48 0v.31h48v-.62H48V0Zm48 0h-.31v16h.62V0H96Zm0 16v-.31H48v.62h48V16Z"
        mask="url(#researchRepository-h)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M55.27 6a.62.62 0 0 1 .44-.18h1.31c.35 0 .63.28.63.62v1.32c0 .17-.07.32-.19.44L55.67 10a.62.62 0 0 1-.88 0l-1.31-1.32a.62.62 0 0 1 0-.88L55.27 6Zm.44.29a.16.16 0 0 0-.11.04l-1.8 1.8a.16.16 0 0 0 0 .21l1.32 1.32c.07.06.16.06.22 0l1.8-1.79a.16.16 0 0 0 .04-.1V6.43a.16.16 0 0 0-.16-.15h-1.31Z"
        clipRule="evenodd"
      />
      <path
        fill={templateStyles['icon']}
        d="M56.09 7.07a.31.31 0 1 1 .62 0 .31.31 0 0 1-.62 0Z"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={60.45} y={9.16}>
          {formatMessage(researchRepositoryMessages['research-repository.field-2-name'])}
        </tspan>
      </text>
      <mask id="researchRepository-i" fill={templateStyles['background']}>
        <path d="M48 16h48v18.67H48V16Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M96 34.67v.3h.31v-.3H96ZM95.69 16v18.67h.62V16h-.62ZM96 34.36H48v.62h48v-.62Z"
        mask="url(#researchRepository-i)"
      />
      <rect
        width={18.69}
        height={5.91}
        x={51.89}
        y={18.64}
        fill={tagBackgroundColors['orangeLight']}
        rx={0.78}
      />
      <rect
        width={18.69}
        height={5.91}
        x={51.89}
        y={18.64}
        stroke={tagBorderColors['orangeLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={54.19} y={22.76}>
          {formatMessage(
            researchRepositoryMessages['research-repository.field-2-select-option-1']
          )}
        </tspan>
      </text>
      <mask id="researchRepository-j" fill={templateStyles['background']}>
        <path d="M48 34.67h48v18.66H48V34.67Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M96 53.33v.31h.31v-.3H96Zm-.31-18.66v18.66h.62V34.67h-.62ZM96 53.02H48v.62h48v-.62Z"
        mask="url(#researchRepository-j)"
      />
      <rect
        width={31.69}
        height={5.91}
        x={51.89}
        y={37.31}
        fill={tagBackgroundColors['yellowLight']}
        rx={0.78}
      />
      <rect
        width={31.69}
        height={5.91}
        x={51.89}
        y={37.31}
        stroke={tagBorderColors['yellowLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={54.03} y={41.43}>
          {formatMessage(
            researchRepositoryMessages['research-repository.field-2-select-option-2']
          )}
        </tspan>
      </text>
      <mask id="researchRepository-k" fill={templateStyles['background']}>
        <path d="M48 53.33h48v31.11H48v-31.1Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M96 84.44v.32h.31v-.32H96Zm-.31-31.1v31.1h.62v-31.1h-.62Zm.31 30.8H48v.62h48v-.63Z"
        mask="url(#researchRepository-k)"
      />
      <rect
        width={28.69}
        height={5.91}
        x={51.89}
        y={55.98}
        fill={tagBackgroundColors['limeLight']}
        rx={0.78}
      />
      <rect
        width={28.69}
        height={5.91}
        x={51.89}
        y={55.98}
        stroke={tagBorderColors['limeLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={53.76} y={60.09}>
          {formatMessage(
            researchRepositoryMessages['research-repository.field-2-select-option-3']
          )}
        </tspan>
      </text>
      <mask id="researchRepository-l" fill={templateStyles['background']}>
        <path d="M48 84.44h48v24.9H48v-24.9Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M96 109.33v.31h.31v-.3H96Zm-.31-24.89v24.9h.62v-24.9h-.62Zm.31 24.58H48v.62h48v-.62Z"
        mask="url(#researchRepository-l)"
      />
      <rect
        width={29.69}
        height={5.91}
        x={51.89}
        y={87.09}
        fill={tagBackgroundColors['tealLight']}
        rx={0.78}
      />
      <rect
        width={29.69}
        height={5.91}
        x={51.89}
        y={87.09}
        stroke={tagBorderColors['tealLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={53.95} y={91.2}>
          {formatMessage(
            researchRepositoryMessages['research-repository.field-2-select-option-4']
          )}
        </tspan>
      </text>
      <mask id="researchRepository-m" fill={templateStyles['background']}>
        <path d="M48 109.33h48V128H48v-18.67Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M96 128v.31h.31V128H96Zm-.31-18.67V128h.62v-18.67h-.62ZM96 127.7H48v.62h48v-.62Z"
        mask="url(#researchRepository-m)"
      />
      <rect
        width={27.69}
        height={5.69}
        x={51.89}
        y={111.98}
        fill={tagBackgroundColors['magentaLight']}
        rx={0.78}
      />
      <rect
        width={27.69}
        height={5.69}
        x={51.89}
        y={111.98}
        stroke={tagBorderColors['magentaLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={54.15} y={115.98}>
          {formatMessage(
            researchRepositoryMessages['research-repository.field-2-select-option-5']
          )}
        </tspan>
      </text>
      <path fill={templateStyles['background']} d="M96 0h48v128H96z" />
      <mask id="researchRepository-n" fill={templateStyles['background']}>
        <path d="M96 0h48v16H96V0Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M144 0h.31v-.31H144V0Zm0 16v.31h.31V16H144ZM96 0v.31h48v-.62H96V0Zm48 0h-.31v16h.62V0H144Zm0 16v-.31H96v.62h48V16Z"
        mask="url(#researchRepository-n)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M105.65 6.6h-4.36v-.47h4.36v.47Zm0 1.63h-4.36v-.46h4.36v.46Zm-2.18 1.64h-2.18V9.4h2.18v.47Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={108.45} y={9.16}>
          {formatMessage(researchRepositoryMessages['research-repository.field-3-name'])}
        </tspan>
      </text>
      <g clipPath="url(#researchRepository-o)">
        <mask id="researchRepository-p" fill={templateStyles['background']}>
          <path d="M96 16h48v18.67H96V16Z" />
        </mask>
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontHeading']}
          fontSize={4.36}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={99.73} y={23.15}>
            {formatMessage(
              researchRepositoryMessages['research-repository.entry-1-cell-3']
            ).substring(0, 10)}
          </tspan>
          <tspan x={98.73} y={29.37}>
            {formatMessage(
              researchRepositoryMessages['research-repository.entry-1-cell-3']
            ).substring(10)}
          </tspan>
        </text>
      </g>
      <path
        fill="#DDE0E5"
        d="M144 34.67v.3h.31v-.3H144ZM143.69 16v18.67h.62V16h-.62Zm.31 18.36H96v.62h48v-.62Z"
        mask="url(#researchRepository-p)"
      />
      <g clipPath="url(#researchRepository-q)">
        <mask id="researchRepository-r" fill={templateStyles['background']}>
          <path d="M96 34.67h48v18.66H96V34.67Z" />
        </mask>
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontHeading']}
          fontSize={4.36}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={99.73} y={41.81}>
            {formatMessage(
              researchRepositoryMessages['research-repository.entry-2-cell-3']
            ).substring(0, 19)}
          </tspan>
          <tspan x={99.73} y={48.04}>
            {formatMessage(
              researchRepositoryMessages['research-repository.entry-2-cell-3']
            ).substring(19)}
          </tspan>
        </text>
      </g>
      <path
        fill="#DDE0E5"
        d="M144 53.33v.31h.31v-.3H144Zm-.31-18.66v18.66h.62V34.67h-.62Zm.31 18.35H96v.62h48v-.62Z"
        mask="url(#researchRepository-r)"
      />
      <mask id="researchRepository-s" fill={templateStyles['background']}>
        <path d="M96 53.33h48v31.11H96v-31.1Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M144 84.44v.32h.31v-.32H144Zm-.31-31.1v31.1h.62v-31.1h-.62Zm.31 30.8H96v.62h48v-.63Z"
        mask="url(#researchRepository-s)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={99.73} y={60.48}>
          {formatMessage(
            researchRepositoryMessages['research-repository.entry-3-cell-3']
          ).substring(0, 20)}
        </tspan>
        <tspan x={98.73} y={66.7}>
          {formatMessage(
            researchRepositoryMessages['research-repository.entry-3-cell-3']
          ).substring(20, 33)}
        </tspan>
        <tspan x={99.73} y={72.93}>
          {formatMessage(
            researchRepositoryMessages['research-repository.entry-3-cell-3']
          ).substring(34, 54)}
        </tspan>
        <tspan x={99.73} y={79.15}>
          {formatMessage(
            researchRepositoryMessages['research-repository.entry-3-cell-3']
          ).substring(54)}
        </tspan>
      </text>
      <mask id="researchRepository-t" fill={templateStyles['background']}>
        <path d="M96 84.44h48v24.9H96v-24.9Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M144 109.33v.31h.31v-.3H144Zm-.31-24.89v24.9h.62v-24.9h-.62Zm.31 24.58H96v.62h48v-.62Z"
        mask="url(#researchRepository-t)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={99.73} y={91.59}>
          {formatMessage(
            researchRepositoryMessages['research-repository.entry-4-cell-3']
          ).substring(0, 11)}
        </tspan>
        <tspan x={98.73} y={97.81}>
          {formatMessage(
            researchRepositoryMessages['research-repository.entry-4-cell-3']
          ).substring(11, 33)}
        </tspan>
        <tspan x={99.73} y={104.04}>
          {formatMessage(
            researchRepositoryMessages['research-repository.entry-4-cell-3']
          ).substring(33)}
        </tspan>
      </text>
      <g clipPath="url(#researchRepository-u)">
        <mask id="researchRepository-v" fill={templateStyles['background']}>
          <path d="M96 109.33h48V128H96v-18.67Z" />
        </mask>
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontHeading']}
          fontSize={4.36}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={99.73} y={116.48}>
            {formatMessage(
              researchRepositoryMessages['research-repository.entry-5-cell-3']
            ).substring(0, 19)}
          </tspan>
          <tspan x={99.73} y={122.7}>
            {formatMessage(
              researchRepositoryMessages['research-repository.entry-5-cell-3']
            ).substring(19)}
          </tspan>
        </text>
      </g>
      <path
        fill="#DDE0E5"
        d="M144 128v.31h.31V128H144Zm-.31-18.67V128h.62v-18.67h-.62Zm.31 18.36H96v.62h48v-.62Z"
        mask="url(#researchRepository-v)"
      />
      <path fill={templateStyles['background']} d="M144 0h48v128h-48z" />
      <mask id="researchRepository-w" fill={templateStyles['background']}>
        <path d="M144 0h48v16h-48V0Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M192 0h.31v-.31H192V0Zm0 16v.31h.31V16H192ZM144 0v.31h48v-.62h-48V0Zm48 0h-.31v16h.62V0H192Zm0 16v-.31h-48v.62h48V16Z"
        mask="url(#researchRepository-w)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M151.27 6a.62.62 0 0 1 .44-.18h1.31c.35 0 .63.28.63.62v1.32c0 .17-.07.32-.19.44l-1.78 1.8a.62.62 0 0 1-.89 0l-1.31-1.32a.62.62 0 0 1 0-.88l1.79-1.8Zm.44.29a.16.16 0 0 0-.11.04l-1.8 1.8a.16.16 0 0 0 0 .21l1.32 1.32c.06.06.16.06.22 0l1.8-1.79a.16.16 0 0 0 .04-.1V6.43a.16.16 0 0 0-.16-.15h-1.31Z"
        clipRule="evenodd"
      />
      <path
        fill={templateStyles['icon']}
        d="M152.09 7.07a.31.31 0 1 1 .62 0 .31.31 0 0 1-.62 0Z"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={156.45} y={9.16}>
          {formatMessage(researchRepositoryMessages['research-repository.field-4-name'])}
        </tspan>
      </text>
      <mask id="researchRepository-x" fill={templateStyles['background']}>
        <path d="M144 16h48v18.67h-48V16Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M192 34.67v.3h.31v-.3H192ZM191.69 16v18.67h.62V16h-.62Zm.31 18.36h-48v.62h48v-.62Z"
        mask="url(#researchRepository-x)"
      />
      <rect
        width={15.69}
        height={5.91}
        x={147.89}
        y={18.64}
        fill={tagBackgroundColors['greyLight']}
        rx={0.78}
      />
      <rect
        width={15.69}
        height={5.91}
        x={147.89}
        y={18.64}
        stroke={tagBorderColors['greyLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={150.04} y={22.76}>
          {formatMessage(
            researchRepositoryMessages['research-repository.field-4-select-option-1']
          )}
        </tspan>
      </text>
      <mask id="researchRepository-y" fill={templateStyles['background']}>
        <path d="M144 34.67h48v18.66h-48V34.67Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M192 53.33v.31h.31v-.3H192Zm-.31-18.66v18.66h.62V34.67h-.62Zm.31 18.35h-48v.62h48v-.62Z"
        mask="url(#researchRepository-y)"
      />
      <rect
        width={21.69}
        height={5.91}
        x={147.89}
        y={37.31}
        fill={tagBackgroundColors['purpleLight']}
        rx={0.78}
      />
      <rect
        width={21.69}
        height={5.91}
        x={147.89}
        y={37.31}
        stroke={tagBorderColors['purpleLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={149.92} y={41.43}>
          {formatMessage(
            researchRepositoryMessages['research-repository.field-4-select-option-2']
          )}
        </tspan>
      </text>
      <mask id="researchRepository-z" fill={templateStyles['background']}>
        <path d="M144 53.33h48v31.11h-48v-31.1Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M192 84.44v.32h.31v-.32H192Zm-.31-31.1v31.1h.62v-31.1h-.62Zm.31 30.8h-48v.62h48v-.63Z"
        mask="url(#researchRepository-z)"
      />
      <rect
        width={27.69}
        height={5.91}
        x={147.89}
        y={55.98}
        fill={tagBackgroundColors['blueLight']}
        rx={0.78}
      />
      <rect
        width={27.69}
        height={5.91}
        x={147.89}
        y={55.98}
        stroke={tagBorderColors['blueLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={150.23} y={60.09}>
          {formatMessage(
            researchRepositoryMessages['research-repository.field-4-select-option-3']
          )}
        </tspan>
      </text>
      <mask id="researchRepository-A" fill={templateStyles['background']}>
        <path d="M144 84.44h48v24.9h-48v-24.9Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M192 109.33v.31h.31v-.3H192Zm-.31-24.89v24.9h.62v-24.9h-.62Zm.31 24.58h-48v.62h48v-.62Z"
        mask="url(#researchRepository-A)"
      />
      <rect
        width={23.69}
        height={5.91}
        x={147.89}
        y={87.09}
        fill={tagBackgroundColors['greenLight']}
        rx={0.78}
      />
      <rect
        width={23.69}
        height={5.91}
        x={147.89}
        y={87.09}
        stroke={tagBorderColors['greenLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={149.85} y={91.2}>
          {formatMessage(
            researchRepositoryMessages['research-repository.field-4-select-option-4']
          )}
        </tspan>
      </text>
      <mask id="researchRepository-B" fill={templateStyles['background']}>
        <path d="M144 109.33h48V128h-48v-18.67Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M192 128v.31h.31V128H192Zm-.31-18.67V128h.62v-18.67h-.62Zm.31 18.36h-48v.62h48v-.62Z"
        mask="url(#researchRepository-B)"
      />
      <rect
        width={19.69}
        height={5.91}
        x={147.89}
        y={111.98}
        fill={tagBackgroundColors['redLight']}
        rx={0.78}
      />
      <rect
        width={19.69}
        height={5.91}
        x={147.89}
        y={111.98}
        stroke={tagBorderColors['redLight']}
        strokeWidth={0.31}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={150.2} y={116.09}>
          {formatMessage(
            researchRepositoryMessages['research-repository.field-4-select-option-5']
          )}
        </tspan>
      </text>
      <path fill={templateStyles['background']} d="M192 0h48v128h-48z" />
      <mask id="researchRepository-C" fill={templateStyles['background']}>
        <path d="M192 0h48v16h-48V0Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M240 0h.31v-.31H240V0Zm0 16v.31h.31V16H240ZM192 0v.31h48v-.62h-48V0Zm48 0h-.31v16h.62V0H240Zm0 16v-.31h-48v.62h48V16Z"
        mask="url(#researchRepository-C)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M199.47 5.98a.78.78 0 1 0 0 1.55.78.78 0 0 0 0-1.55Zm-1.25.78a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm-.62 2.8c0-.65.52-1.17 1.17-1.17h1.4c.64 0 1.17.52 1.17 1.17v.62h-.47v-.62a.7.7 0 0 0-.7-.7h-1.4a.7.7 0 0 0-.7.7v.62h-.47v-.62Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={204.45} y={9.55}>
          {formatMessage(researchRepositoryMessages['research-repository.field-5-name'])}
        </tspan>
      </text>
      <mask id="researchRepository-D" fill={templateStyles['background']}>
        <path d="M192 16h48v18.67h-48V16Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M240 34.67v.3h.31v-.3H240ZM240 16h-.31v18.67h.62V16H240Zm0 18.67v-.31h-48v.62h48v-.31Z"
        mask="url(#researchRepository-D)"
      />
      <rect
        width={28.16}
        height={6.22}
        x={195.73}
        y={18.49}
        fill={templateStyles['userBackground']}
        rx={3.11}
      />
      <path
        fill={templateStyles['fontColor']}
        d="M199.07 23.99c-1.1 0-1.79-.7-1.79-1.78 0-1.05.72-1.77 1.76-1.77 1 0 1.7.64 1.7 1.56 0 .7-.3 1.14-.8 1.14-.24 0-.43-.14-.46-.35v-.01h-.04a.55.55 0 0 1-.53.34c-.44 0-.74-.37-.74-.9 0-.52.3-.89.74-.89.22 0 .42.12.5.3h.03v-.26h.32v1.25c0 .15.1.24.24.24.27 0 .44-.34.44-.86 0-.77-.58-1.3-1.43-1.3-.83 0-1.43.64-1.43 1.52 0 .91.59 1.5 1.5 1.5.29 0 .58-.04.71-.1v.26c-.19.07-.45.1-.72.1Zm-.11-1.17c.3 0 .48-.23.48-.6 0-.36-.19-.6-.48-.6-.28 0-.45.23-.45.6s.17.6.45.6Z"
      />
      <path
        fill={templateStyles['fontColor']}
        d="M202.04 23.1v-3.07h.38v2.73h1.48v.34h-1.86Zm3.25.04c-.21 0-.4-.05-.56-.14a.96.96 0 0 1-.36-.41 1.45 1.45 0 0 1-.13-.63c0-.24.04-.44.13-.62a1 1 0 0 1 .36-.42c.15-.1.33-.15.54-.15.2 0 .39.05.54.14.15.1.26.23.34.4.08.18.12.38.12.6v.15h-1.84v-.3h1.65l-.18.27v-.14c0-.18-.03-.33-.08-.45a.57.57 0 0 0-.55-.34.61.61 0 0 0-.33.09.61.61 0 0 0-.23.26.99.99 0 0 0-.09.44v.14c0 .17.03.3.09.42a.62.62 0 0 0 .6.36c.1 0 .19-.01.26-.04a.6.6 0 0 0 .2-.11.4.4 0 0 0 .1-.13v-.02h.38l-.01.01a.7.7 0 0 1-.1.23.85.85 0 0 1-.2.2.99.99 0 0 1-.28.14c-.11.03-.23.05-.37.05Zm2.34 0c-.17 0-.32-.03-.45-.08a.79.79 0 0 1-.31-.22.62.62 0 0 1-.14-.32h.38c.03.09.09.17.18.22a.76.76 0 0 0 .63.04.46.46 0 0 0 .18-.12.28.28 0 0 0 .07-.18.25.25 0 0 0-.09-.2.72.72 0 0 0-.3-.14l-.36-.08a1.3 1.3 0 0 1-.35-.14.55.55 0 0 1-.2-.2.59.59 0 0 1-.08-.28c0-.13.04-.25.12-.35.07-.1.17-.18.3-.24.13-.05.28-.08.44-.08.16 0 .3.02.42.07.13.05.23.12.3.22.08.09.13.2.14.32h-.36a.37.37 0 0 0-.17-.22.6.6 0 0 0-.33-.08c-.1 0-.18.01-.25.04a.4.4 0 0 0-.16.12.27.27 0 0 0-.07.18c0 .05.02.1.04.14.03.04.07.07.13.1s.13.06.22.08l.35.09c.22.05.38.12.48.22.1.1.16.23.16.4 0 .14-.04.26-.12.36a.8.8 0 0 1-.33.24c-.14.06-.3.09-.47.09Zm1.52-.04v-3.2h.37v3.2h-.37Zm1.09 0v-2.3h.37v2.3h-.37Zm.18-2.74a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.08c.07 0 .14.03.18.08a.25.25 0 0 1 0 .36.24.24 0 0 1-.18.07Zm1.82 2.78c-.22 0-.4-.05-.56-.14a.96.96 0 0 1-.37-.41 1.45 1.45 0 0 1-.12-.63c0-.24.04-.44.13-.62a1 1 0 0 1 .35-.42c.16-.1.34-.15.55-.15.2 0 .38.05.53.14.15.1.27.23.35.4.08.18.12.38.12.6v.15h-1.84v-.3h1.65l-.18.27v-.14c0-.18-.03-.33-.09-.45a.57.57 0 0 0-.55-.34.61.61 0 0 0-.33.09.61.61 0 0 0-.23.26.99.99 0 0 0-.08.44v.14c0 .17.03.3.08.42a.62.62 0 0 0 .6.36c.1 0 .2-.01.27-.04a.6.6 0 0 0 .19-.11.4.4 0 0 0 .1-.13l.01-.02h.37v.01a.7.7 0 0 1-.11.23.85.85 0 0 1-.2.2.98.98 0 0 1-.28.14c-.1.03-.22.05-.36.05Zm3.67-.04v-1.32l-1.09-1.75h.44l.82 1.36h.04l.82-1.36h.44l-1.09 1.75v1.32h-.38Zm2.47.04a.89.89 0 0 1-.43-.1.64.64 0 0 1-.27-.29 1.11 1.11 0 0 1-.09-.46v-1.48h.38v1.4c0 .2.03.35.11.45.08.1.22.15.4.15.1 0 .19-.01.27-.04a.52.52 0 0 0 .2-.13c.04-.06.08-.12.1-.2a.86.86 0 0 0 .05-.28v-1.35h.37v2.29h-.37v-.34h-.03a.65.65 0 0 1-.16.2.66.66 0 0 1-.23.14.94.94 0 0 1-.3.04Zm1.78.73V20.8h.37v.36h.03a.75.75 0 0 1 .42-.35c.1-.04.2-.05.3-.05.2 0 .36.05.5.15.15.1.26.23.34.4.08.19.12.4.12.63 0 .25-.04.45-.12.63a.88.88 0 0 1-.84.56.84.84 0 0 1-.54-.19.68.68 0 0 1-.18-.21h-.03v1.13h-.37Zm1.03-1.06c.14 0 .26-.03.36-.1.1-.07.18-.17.23-.3.05-.12.08-.28.08-.45 0-.19-.03-.34-.08-.47a.64.64 0 0 0-.23-.3.61.61 0 0 0-.36-.1.62.62 0 0 0-.36.1.66.66 0 0 0-.23.3c-.05.13-.08.28-.08.46s.03.33.08.46c.06.13.13.23.23.3.1.07.22.1.36.1Z"
      />
      <mask id="researchRepository-E" fill={templateStyles['background']}>
        <path d="M192 34.67h48v18.66h-48V34.67Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M240 53.33v.31h.31v-.3H240Zm0-18.66h-.31v18.66h.62V34.67H240Zm0 18.66v-.3h-48v.61h48v-.3Z"
        mask="url(#researchRepository-E)"
      />
      <rect
        width={34.16}
        height={6.22}
        x={195.73}
        y={37.16}
        fill={templateStyles['userBackground']}
        rx={3.11}
      />
      <path
        fill={templateStyles['fontColor']}
        d="M199.07 42.65c-1.1 0-1.79-.69-1.79-1.77 0-1.06.72-1.78 1.76-1.78 1 0 1.7.65 1.7 1.57 0 .7-.3 1.13-.8 1.13-.24 0-.43-.14-.46-.34v-.01h-.04a.55.55 0 0 1-.53.33c-.44 0-.74-.36-.74-.9 0-.52.3-.88.74-.88.22 0 .42.12.5.3h.03v-.26h.32v1.25c0 .15.1.24.24.24.27 0 .44-.34.44-.86 0-.77-.58-1.3-1.43-1.3-.83 0-1.43.64-1.43 1.52 0 .9.59 1.5 1.5 1.5.29 0 .58-.05.71-.1v.26c-.19.06-.45.1-.72.1Zm-.11-1.17c.3 0 .48-.23.48-.59 0-.37-.19-.6-.48-.6-.28 0-.45.23-.45.6s.17.6.45.6Z"
      />
      <path
        fill={templateStyles['fontColor']}
        d="M202.04 41.77V38.7h1.17c.2 0 .37.04.51.11.15.08.26.18.34.32.09.14.13.3.13.48 0 .22-.06.4-.17.56a.85.85 0 0 1-.45.32l.7 1.28h-.44l-.66-1.22h-.75v1.22h-.38Zm.38-1.56h.75c.2 0 .35-.05.46-.15.1-.1.16-.25.16-.43a.56.56 0 0 0-.17-.44.66.66 0 0 0-.46-.15h-.74v1.17Zm3.3 1.6c-.22 0-.41-.05-.57-.15a.97.97 0 0 1-.37-.4 1.45 1.45 0 0 1-.12-.64c0-.25.04-.46.12-.64a.96.96 0 0 1 .93-.55c.22 0 .4.05.57.15.15.1.28.23.36.4.09.18.13.4.13.64 0 .25-.04.46-.13.63a.95.95 0 0 1-.93.56Zm0-.33c.14 0 .26-.03.36-.1.1-.07.18-.17.23-.3.05-.12.08-.28.08-.46s-.03-.34-.08-.47a.62.62 0 0 0-.23-.29.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3c-.05.12-.08.28-.08.46s.03.34.08.46c.06.13.13.23.23.3.1.07.23.1.37.1Zm1.62.29v-2.3h.37v.35h.04a.65.65 0 0 1 .25-.28c.1-.07.25-.1.42-.1.25 0 .45.07.59.21.14.15.2.36.2.63v1.49h-.36v-1.4c0-.2-.05-.36-.13-.46-.1-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.21.22.77.77 0 0 0-.08.35v1.36h-.37Zm4.48.07c-.14 0-.25-.02-.36-.06a.75.75 0 0 1-.43-.4.92.92 0 0 1-.08-.31v-.03h.38v.02c.01.08.04.15.07.21.04.07.1.12.16.16.07.04.15.06.25.06.18 0 .3-.05.4-.15.08-.1.13-.24.13-.43V38.7h.38v2.21c0 .2-.04.36-.1.5a.74.74 0 0 1-.32.32 1 1 0 0 1-.48.1Zm2.58-.03c-.22 0-.4-.05-.56-.15a.96.96 0 0 1-.37-.4 1.45 1.45 0 0 1-.13-.64c0-.25.04-.46.13-.64.09-.17.2-.3.37-.4.15-.1.34-.15.56-.15.22 0 .4.05.56.15.16.1.28.23.37.4.08.18.13.4.13.64 0 .25-.05.46-.13.63a.95.95 0 0 1-.93.56Zm0-.33c.14 0 .27-.03.37-.1.1-.07.17-.17.23-.3.05-.12.08-.28.08-.46s-.03-.34-.08-.47a.62.62 0 0 0-.23-.29.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3 1.2 1.2 0 0 0-.08.46c0 .18.03.34.08.46.05.13.13.23.23.3.1.07.22.1.37.1Zm1.65.29v-3.2h.37v1.25h.04a.65.65 0 0 1 .25-.28c.1-.07.24-.1.41-.1.17 0 .32.03.44.1.12.06.2.15.27.28.06.13.1.28.1.46v1.49h-.38v-1.4c0-.2-.04-.36-.13-.46-.08-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.36h-.37Zm2.54 0v-2.3h.38v.35h.03a.64.64 0 0 1 .25-.28c.1-.07.25-.1.42-.1.25 0 .45.07.59.21.14.15.2.36.2.63v1.49h-.36v-1.4c0-.2-.05-.36-.13-.46-.09-.1-.22-.15-.4-.15a.62.62 0 0 0-.32.08.54.54 0 0 0-.21.22.77.77 0 0 0-.07.35v1.36h-.38Zm3.34.04c-.18 0-.33-.03-.46-.08a.8.8 0 0 1-.31-.22.6.6 0 0 1-.14-.33h.38c.03.1.1.17.18.23.1.06.21.09.36.09.1 0 .2-.02.27-.05a.47.47 0 0 0 .19-.12.28.28 0 0 0 .06-.19.25.25 0 0 0-.09-.2.73.73 0 0 0-.3-.13l-.36-.09a1.3 1.3 0 0 1-.35-.13.55.55 0 0 1-.2-.2.59.59 0 0 1-.07-.29c0-.13.03-.24.1-.34.08-.1.19-.18.31-.24.13-.06.28-.09.44-.09.16 0 .3.03.43.08.12.05.22.12.3.21.07.1.12.2.14.33h-.37a.38.38 0 0 0-.16-.22.6.6 0 0 0-.34-.09c-.1 0-.17.02-.25.05a.4.4 0 0 0-.16.12.28.28 0 0 0-.06.17c0 .06 0 .1.04.14.02.04.06.08.12.1.06.04.13.06.22.09l.35.08c.22.06.38.13.48.23.11.1.16.23.16.4 0 .13-.04.25-.12.36a.8.8 0 0 1-.33.24c-.13.06-.3.09-.46.09Zm2.43 0c-.22 0-.4-.05-.56-.15a.96.96 0 0 1-.37-.4 1.45 1.45 0 0 1-.13-.64c0-.25.05-.46.13-.64.09-.17.2-.3.37-.4.16-.1.34-.15.56-.15.22 0 .4.05.56.15.16.1.28.23.37.4.08.18.13.4.13.64 0 .25-.05.46-.13.63a.95.95 0 0 1-.93.56Zm0-.33c.14 0 .27-.03.37-.1.1-.07.18-.17.23-.3.05-.12.08-.28.08-.46s-.03-.34-.08-.47a.62.62 0 0 0-.23-.29.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3c-.05.12-.08.28-.08.46s.03.34.08.46c.05.13.13.23.23.3.1.07.22.1.37.1Zm1.63.29v-2.3h.37v.35h.03a.65.65 0 0 1 .26-.28c.1-.07.24-.1.41-.1.26 0 .46.07.6.21.13.15.2.36.2.63v1.49h-.37v-1.4c0-.2-.04-.36-.13-.46-.08-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.2.22.76.76 0 0 0-.08.35v1.36H226Z"
      />
      <mask id="researchRepository-F" fill={templateStyles['background']}>
        <path d="M192 53.33h48v31.11h-48v-31.1Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M240 84.44v.32h.31v-.32H240Zm0-31.1h-.31v31.1h.62v-31.1H240Zm0 31.1v-.3h-48v.62h48v-.32Z"
        mask="url(#researchRepository-F)"
      />
      <rect
        width={36.16}
        height={6.22}
        x={195.73}
        y={55.82}
        fill={templateStyles['userBackground']}
        rx={3.11}
      />
      <path
        fill={templateStyles['fontColor']}
        d="M199.07 61.32c-1.1 0-1.79-.69-1.79-1.77 0-1.06.72-1.78 1.76-1.78 1 0 1.7.64 1.7 1.56 0 .7-.3 1.14-.8 1.14-.24 0-.43-.14-.46-.35h-.04a.55.55 0 0 1-.53.33c-.44 0-.74-.36-.74-.9 0-.52.3-.88.74-.88.22 0 .42.11.5.3h.03v-.26h.32v1.25c0 .15.1.23.24.23.27 0 .44-.34.44-.86 0-.77-.58-1.3-1.43-1.3-.83 0-1.43.64-1.43 1.52 0 .91.59 1.5 1.5 1.5.29 0 .58-.04.71-.1v.27c-.19.06-.45.1-.72.1Zm-.11-1.17c.3 0 .48-.23.48-.6 0-.36-.19-.59-.48-.59-.28 0-.45.22-.45.6 0 .36.17.59.45.59Z"
      />
      <path
        fill={templateStyles['fontColor']}
        d="m202.67 60.43-.83-3.07h.4l.6 2.5h.03l.69-2.5h.39l.68 2.5h.03l.6-2.5h.4l-.83 3.07h-.36l-.7-2.42h-.03l-.7 2.42h-.37Zm3.67.8a.88.88 0 0 1-.17 0v-.31a.4.4 0 0 0 .41-.07.56.56 0 0 0 .17-.28l.04-.13-.85-2.3h.4l.7 2.12-.14-.23h.17l-.15.23.7-2.12h.4l-.9 2.43c-.06.18-.13.3-.2.4a.57.57 0 0 1-.24.2c-.1.05-.2.07-.34.07Zm2.71-.76a.9.9 0 0 1-.4-.08.68.68 0 0 1-.27-.24.64.64 0 0 1-.1-.36c0-.14.04-.25.1-.35.07-.1.16-.17.29-.23.12-.05.27-.09.45-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.31.31 0 0 0-.12.27c0 .12.05.21.13.28.1.06.2.1.34.1.12 0 .23-.03.33-.08s.18-.12.23-.2a.52.52 0 0 0 .09-.3v-.72c0-.14-.05-.25-.13-.32-.09-.07-.22-.11-.39-.11a.68.68 0 0 0-.34.07.36.36 0 0 0-.17.2v.01h-.37a.61.61 0 0 1 .15-.32.8.8 0 0 1 .3-.21c.14-.05.28-.08.44-.08.2 0 .35.03.48.1.13.05.23.14.3.26.06.1.1.24.1.4v1.57h-.37v-.33h-.04a.78.78 0 0 1-.4.33.91.91 0 0 1-.29.04Zm2.59-.02c-.24 0-.4-.05-.51-.14-.11-.1-.16-.25-.16-.47v-1.4h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.03.24.08.3.05.05.13.08.25.08a1.4 1.4 0 0 0 .17 0v.3a2.8 2.8 0 0 1-.21.03Zm1.58 0c-.23 0-.4-.05-.51-.14-.1-.1-.16-.25-.16-.47v-1.4h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.03.24.08.3.05.05.14.08.25.08a1.38 1.38 0 0 0 .18 0v.3a2.76 2.76 0 0 1-.22.03Zm2.23-.02v-.33h.95c.23 0 .4-.05.53-.14.11-.1.17-.23.17-.4a.5.5 0 0 0-.08-.3.5.5 0 0 0-.25-.18 1.2 1.2 0 0 0-.4-.06h-.92v-.33h.8a.9.9 0 0 0 .53-.13c.12-.08.18-.2.18-.36a.43.43 0 0 0-.17-.37.68.68 0 0 0-.44-.13h-.9v-.34h.98c.2 0 .35.04.49.1a.7.7 0 0 1 .42.67.7.7 0 0 1-.26.54.59.59 0 0 1-.27.12v.04c.14.01.26.05.37.12a.74.74 0 0 1 .32.62c0 .18-.04.34-.13.47a.8.8 0 0 1-.35.3c-.16.06-.34.1-.56.1h-1Zm-.19 0v-3.07h.38v3.07h-.38Zm3.75.04c-.22 0-.4-.04-.56-.14a.96.96 0 0 1-.36-.4 1.46 1.46 0 0 1-.13-.63c0-.24.04-.45.13-.63a.97.97 0 0 1 .9-.57c.2 0 .39.05.53.14.15.1.27.24.35.4.08.18.12.38.12.6v.15h-1.84v-.3h1.65l-.18.28v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.55-.35.61.61 0 0 0-.34.1.62.62 0 0 0-.23.26 1 1 0 0 0-.08.43v.15c0 .16.03.3.08.42.06.11.14.2.24.26a.78.78 0 0 0 .63.05.58.58 0 0 0 .19-.1.38.38 0 0 0 .1-.14l.01-.02h.37v.02a.71.71 0 0 1-.1.22.84.84 0 0 1-.2.2 1 1 0 0 1-.28.14c-.11.04-.23.05-.37.05Zm1.55-.04v-2.29h.37v.35h.04a.65.65 0 0 1 .25-.29c.1-.07.25-.1.42-.1.25 0 .45.07.59.22.14.15.2.36.2.63v1.48h-.36v-1.4c0-.2-.05-.35-.13-.45-.1-.1-.23-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.21.22.77.77 0 0 0-.08.35v1.35h-.37Zm3.33.04c-.17 0-.32-.02-.45-.07a.79.79 0 0 1-.31-.22.62.62 0 0 1-.14-.33h.38c.03.1.1.17.18.23.1.06.21.09.36.09.1 0 .2-.02.27-.05a.46.46 0 0 0 .19-.12.28.28 0 0 0 .06-.19.25.25 0 0 0-.09-.2.72.72 0 0 0-.3-.14l-.36-.08a1.3 1.3 0 0 1-.35-.13.55.55 0 0 1-.2-.2.59.59 0 0 1-.07-.29c0-.13.03-.24.1-.34.08-.1.18-.18.31-.24s.28-.09.44-.09c.16 0 .3.03.43.08.12.05.22.12.3.2.07.1.12.21.14.33h-.37a.37.37 0 0 0-.16-.22.6.6 0 0 0-.34-.08c-.1 0-.17.01-.25.04a.4.4 0 0 0-.16.12.28.28 0 0 0-.06.18c0 .06 0 .1.03.14.03.04.07.08.13.1.06.04.13.06.22.08l.35.09c.22.05.38.13.48.22.11.1.16.23.16.4 0 .14-.04.26-.12.36a.8.8 0 0 1-.33.25c-.14.05-.3.08-.47.08Zm2.44 0c-.22 0-.4-.04-.56-.14a.96.96 0 0 1-.37-.4 1.45 1.45 0 0 1-.13-.64c0-.25.04-.46.13-.64s.2-.31.37-.4c.16-.1.34-.15.56-.15.22 0 .4.05.56.14.16.1.28.23.37.41.08.18.13.39.13.63 0 .25-.05.46-.13.64a.95.95 0 0 1-.93.55Zm0-.32c.14 0 .27-.04.37-.1.1-.07.18-.17.23-.3.05-.13.08-.28.08-.46 0-.19-.03-.34-.08-.47a.62.62 0 0 0-.23-.29.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3 1.2 1.2 0 0 0-.08.45c0 .19.03.34.08.47.05.13.13.23.23.3.1.06.22.1.37.1Zm1.63.28v-2.29h.37v.35h.03a.65.65 0 0 1 .26-.29c.1-.07.24-.1.41-.1.26 0 .46.07.6.22.13.15.2.36.2.63v1.48h-.37v-1.4c0-.2-.04-.35-.13-.45-.08-.1-.22-.15-.4-.15a.62.62 0 0 0-.32.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.35h-.37Z"
      />
      <mask id="researchRepository-G" fill={templateStyles['background']}>
        <path d="M192 84.44h48v24.9h-48v-24.9Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M240 109.33v.31h.31v-.3H240Zm0-24.89h-.31v24.9h.62v-24.9H240Zm0 24.9v-.32h-48v.62h48v-.3Z"
        mask="url(#researchRepository-G)"
      />
      <rect
        width={32.16}
        height={6.22}
        x={195.73}
        y={86.93}
        fill={templateStyles['userBackground']}
        rx={3.11}
      />
      <path
        fill={templateStyles['fontColor']}
        d="M199.07 92.43c-1.1 0-1.79-.69-1.79-1.77 0-1.06.72-1.78 1.76-1.78 1 0 1.7.64 1.7 1.56 0 .7-.3 1.14-.8 1.14-.24 0-.43-.14-.46-.34v-.02h-.04a.55.55 0 0 1-.53.34c-.44 0-.74-.36-.74-.9 0-.52.3-.88.74-.88.22 0 .42.11.5.3h.03v-.26h.32v1.25c0 .15.1.23.24.23.27 0 .44-.33.44-.86 0-.77-.58-1.3-1.43-1.3-.83 0-1.43.64-1.43 1.53 0 .9.59 1.5 1.5 1.5.29 0 .58-.05.71-.11v.27c-.19.06-.45.1-.72.1Zm-.11-1.17c.3 0 .48-.23.48-.6 0-.36-.19-.59-.48-.59-.28 0-.45.22-.45.6 0 .37.17.6.45.6Z"
      />
      <path
        fill={templateStyles['fontColor']}
        d="m201.8 91.54 1.12-3.06h.3v.5h-.13l-.9 2.56h-.4Zm.5-.87.12-.33h1.39l.12.33h-1.63Zm1.73.87-.9-2.57v-.5h.17l1.13 3.07h-.4Zm.9 0v-2.29h.36v.35h.04a.65.65 0 0 1 .25-.29c.1-.06.25-.1.42-.1.25 0 .45.08.59.22.14.15.2.36.2.63v1.48h-.36v-1.4c0-.2-.05-.35-.13-.45-.1-.1-.23-.15-.4-.15a.61.61 0 0 0-.33.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.35h-.37Zm2.54 0v-2.29h.37v.35h.03a.66.66 0 0 1 .25-.29c.11-.06.25-.1.42-.1.26 0 .46.08.6.22.13.15.2.36.2.63v1.48h-.37v-1.4c0-.2-.04-.35-.13-.45-.09-.1-.22-.15-.4-.15a.62.62 0 0 0-.32.08.54.54 0 0 0-.21.22.77.77 0 0 0-.07.35v1.35h-.37Zm3.48.04c-.22 0-.4-.04-.57-.14a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.12-.63c0-.24.04-.45.12-.63a1 1 0 0 1 .36-.42c.16-.1.34-.15.54-.15a.93.93 0 0 1 .88.55c.08.17.13.37.13.6v.14h-1.84v-.3h1.65l-.19.28v-.15c0-.18-.02-.33-.08-.44a.57.57 0 0 0-.55-.35.62.62 0 0 0-.33.1.61.61 0 0 0-.23.26.99.99 0 0 0-.09.43v.15c0 .16.03.3.09.42a.61.61 0 0 0 .6.36c.1 0 .19-.02.26-.05a.6.6 0 0 0 .2-.1.4.4 0 0 0 .1-.14v-.02h.38v.02a.7.7 0 0 1-.11.23.85.85 0 0 1-.2.2.98.98 0 0 1-.28.13c-.1.04-.23.05-.36.05Zm2.82-.04v-3.06h.38v2.72h1.48v.34h-1.86Zm3.06.04a.9.9 0 0 1-.4-.08.67.67 0 0 1-.27-.23.64.64 0 0 1-.1-.37.6.6 0 0 1 .1-.35c.07-.1.16-.17.29-.23.12-.05.27-.09.45-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.12.27c0 .12.05.21.13.28.1.06.2.1.34.1.12 0 .23-.03.33-.08a.6.6 0 0 0 .23-.2.53.53 0 0 0 .09-.3v-.72c0-.14-.05-.24-.13-.32-.09-.07-.22-.11-.39-.11a.68.68 0 0 0-.34.07.36.36 0 0 0-.17.21h-.38a.62.62 0 0 1 .16-.32.8.8 0 0 1 .3-.21c.14-.05.28-.08.44-.08.2 0 .35.03.48.1.13.05.23.14.3.26.06.11.1.25.1.4v1.57h-.37v-.33h-.04a.78.78 0 0 1-.4.33.9.9 0 0 1-.3.04Zm1.77-.04v-2.29h.37v.34h.04a.54.54 0 0 1 .22-.28c.1-.07.24-.1.39-.1h.1l.09.02v.36a1.11 1.11 0 0 0-.23-.03.68.68 0 0 0-.32.07.54.54 0 0 0-.21.2.55.55 0 0 0-.08.3v1.41h-.37Zm1.68 0v-3.2h.37v3.2h-.37Zm1.45 0-.9-1.12.27-.23 1.1 1.35h-.47Zm-1.12-.82-.02-.47h.1l.99-1h.45l-1.1 1.05-.08.09-.34.33Zm2.02.82v-2.29h.38v2.3h-.38Zm.2-2.73a.25.25 0 0 1-.19-.08.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.07c.07 0 .13.02.18.07a.25.25 0 0 1 0 .36.25.25 0 0 1-.18.08Zm.87 2.73v-2.29h.37v.35h.04a.65.65 0 0 1 .25-.29c.1-.06.25-.1.41-.1.26 0 .46.08.6.22.14.15.2.36.2.63v1.48h-.36v-1.4c0-.2-.05-.35-.14-.45-.08-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.35h-.37Z"
      />
      <mask id="researchRepository-H" fill={templateStyles['background']}>
        <path d="M192 109.33h48V128h-48v-18.67Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M240 128v.31h.31V128H240Zm0-18.67h-.31V128h.62v-18.67H240Zm0 18.67v-.31h-48v.62h48V128Z"
        mask="url(#researchRepository-H)"
      />
      <rect
        width={35.16}
        height={6.22}
        x={195.73}
        y={111.82}
        fill={templateStyles['userBackground']}
        rx={3.11}
      />
      <path
        fill={templateStyles['fontColor']}
        d="M199.07 117.32c-1.1 0-1.79-.69-1.79-1.77 0-1.06.72-1.78 1.76-1.78 1 0 1.7.64 1.7 1.56 0 .7-.3 1.14-.8 1.14-.24 0-.43-.14-.46-.34v-.02h-.04a.55.55 0 0 1-.53.34c-.44 0-.74-.36-.74-.9 0-.52.3-.88.74-.88.22 0 .42.11.5.3h.03v-.26h.32v1.25c0 .15.1.23.24.23.27 0 .44-.33.44-.86 0-.77-.58-1.3-1.43-1.3-.83 0-1.43.64-1.43 1.53 0 .9.59 1.49 1.5 1.49.29 0 .58-.04.71-.1v.27c-.19.06-.45.1-.72.1Zm-.11-1.17c.3 0 .48-.23.48-.6 0-.36-.19-.59-.48-.59-.28 0-.45.22-.45.6 0 .36.17.59.45.59Z"
      />
      <path
        fill={templateStyles['fontColor']}
        d="M202.7 116.5a1 1 0 0 1-.36-.05.75.75 0 0 1-.44-.4.95.95 0 0 1-.07-.31v-.03h.38v.02c.01.07.03.14.07.21.04.06.09.12.16.16.07.03.15.05.25.05.17 0 .3-.05.39-.14.09-.1.13-.25.13-.43v-2.22h.39v2.22c0 .2-.04.36-.11.5a.74.74 0 0 1-.31.31 1 1 0 0 1-.49.12Zm2.57-.03c-.22 0-.4-.04-.56-.14a.95.95 0 0 1-.37-.4 1.46 1.46 0 0 1-.12-.63c0-.24.04-.45.12-.63a1 1 0 0 1 .36-.42c.16-.1.34-.15.55-.15a.92.92 0 0 1 .88.55c.08.17.12.37.12.6v.14h-1.84v-.3h1.65l-.19.28v-.15c0-.18-.02-.33-.08-.44a.57.57 0 0 0-.55-.35.61.61 0 0 0-.33.1.63.63 0 0 0-.23.26 1 1 0 0 0-.08.43v.15c0 .16.02.3.08.42.06.11.13.2.23.26s.23.1.37.1c.1 0 .19-.02.27-.05a.6.6 0 0 0 .19-.1.38.38 0 0 0 .1-.14v-.02h.38v.02a.72.72 0 0 1-.11.22.84.84 0 0 1-.2.2 1.03 1.03 0 0 1-.64.2Zm1.55-.04v-2.29h.37v.34h.03a.54.54 0 0 1 .23-.28c.1-.07.23-.1.39-.1h.1l.08.02v.35a1.11 1.11 0 0 0-.23-.02.67.67 0 0 0-.3.07.55.55 0 0 0-.22.2.56.56 0 0 0-.08.3v1.41h-.37Zm1.7 0v-2.29h.37v.34h.04a.54.54 0 0 1 .22-.28c.1-.07.23-.1.39-.1h.1l.08.02v.35a1.13 1.13 0 0 0-.22-.02.67.67 0 0 0-.32.07.53.53 0 0 0-.21.2.56.56 0 0 0-.08.3v1.41h-.37Zm1.88.8a.81.81 0 0 1-.17 0v-.31h.08l.08.01c.1 0 .19-.03.26-.08a.57.57 0 0 0 .16-.28l.04-.13-.85-2.3h.4l.7 2.12-.14-.23h.17l-.14.23.7-2.12h.39l-.9 2.43c-.06.18-.13.3-.2.4a.57.57 0 0 1-.24.2c-.1.05-.2.07-.34.07Zm4.71-.72c-.21 0-.4-.04-.58-.12a1.23 1.23 0 0 1-.43-.32c-.12-.14-.22-.3-.28-.5a2.1 2.1 0 0 1-.1-.67c0-.33.06-.6.17-.85.12-.24.28-.43.49-.56.2-.13.45-.2.73-.2.23 0 .43.04.6.12a1.16 1.16 0 0 1 .68.85v.02h-.38v-.02a.83.83 0 0 0-.33-.46.98.98 0 0 0-.57-.16.92.92 0 0 0-.88.6c-.08.18-.12.4-.12.66 0 .2.02.37.07.52.05.16.11.29.2.4a.9.9 0 0 0 .73.33c.19 0 .35-.03.48-.1a.8.8 0 0 0 .44-.77v-.07h-.86v-.34h1.25v.38c0 .19-.04.36-.1.51a1.13 1.13 0 0 1-.67.66c-.17.06-.34.09-.54.09Zm2.87-.04c-.22 0-.4-.04-.56-.14a.95.95 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.63c0-.24.04-.45.13-.63a1 1 0 0 1 .36-.42c.15-.1.33-.15.54-.15a.92.92 0 0 1 .88.55c.08.17.12.37.12.6v.14h-1.84v-.3h1.65l-.18.28v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.55-.35.61.61 0 0 0-.34.1.62.62 0 0 0-.22.26 1 1 0 0 0-.09.43v.15c0 .16.03.3.08.42.06.11.14.2.24.26.1.06.22.1.36.1.1 0 .2-.02.27-.05a.61.61 0 0 0 .19-.1.4.4 0 0 0 .1-.14l.01-.02h.37v.02a.7.7 0 0 1-.1.22.86.86 0 0 1-.2.2 1.03 1.03 0 0 1-.65.2Zm1.56-.04v-2.29h.37v.34h.03a.54.54 0 0 1 .22-.28c.1-.07.24-.1.4-.1a.7.7 0 0 1 .1 0l.08.02v.35a1.13 1.13 0 0 0-.23-.02.67.67 0 0 0-.31.07.54.54 0 0 0-.22.2.56.56 0 0 0-.07.3v1.41h-.38Zm2.53.81c-.18 0-.34-.02-.48-.08a.8.8 0 0 1-.33-.22.66.66 0 0 1-.15-.32h.39c.02.08.08.15.18.2.1.07.23.1.4.1.2 0 .36-.05.47-.15.12-.09.18-.22.18-.39v-.46h-.03a.78.78 0 0 1-.43.35.95.95 0 0 1-.3.04.93.93 0 0 1-.5-.14.94.94 0 0 1-.34-.39 1.33 1.33 0 0 1-.12-.57c0-.22.04-.4.12-.57.08-.17.2-.3.34-.4.14-.1.31-.14.52-.14a.76.76 0 0 1 .71.42h.03v-.38h.37v2.26c0 .17-.05.32-.13.45a.8.8 0 0 1-.35.29c-.16.07-.34.1-.55.1Zm-.01-1.25c.14 0 .26-.04.36-.1.1-.07.18-.16.23-.28a.92.92 0 0 0 .09-.4.93.93 0 0 0-.09-.4.63.63 0 0 0-.6-.38.63.63 0 0 0-.36.1.64.64 0 0 0-.22.27c-.05.12-.08.26-.08.4v.01a1 1 0 0 0 .08.4c.05.12.13.21.22.28.1.06.22.1.37.1Zm1.73.44v-2.29h.37v2.3h-.37Zm.19-2.73a.25.25 0 0 1-.18-.08.25.25 0 0 1-.08-.18c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.07.25.25 0 0 1 .26.25c0 .07-.03.13-.08.18a.24.24 0 0 1-.18.08Zm1.7 2.75c-.24 0-.41-.05-.52-.14-.1-.1-.16-.25-.16-.47v-1.4h-.36v-.3h.36v-.6h.39v.6h.5v.3h-.5v1.3c0 .14.02.24.07.3.05.05.14.08.26.08H225.89v.3a1.93 1.93 0 0 1-.22.03Zm.78-.02v-3.2h.37v1.25h.04a.65.65 0 0 1 .25-.28c.1-.07.25-.1.41-.1.18 0 .32.03.44.1.12.06.21.16.27.29.07.12.1.28.1.46v1.48h-.37v-1.4c0-.2-.05-.35-.13-.45-.1-.1-.23-.15-.4-.15a.61.61 0 0 0-.33.08.53.53 0 0 0-.2.22.77.77 0 0 0-.08.35v1.35h-.37Z"
      />
      <path fill={templateStyles['background']} d="M240 0h48v128h-48z" />
      <mask id="researchRepository-I" fill={templateStyles['background']}>
        <path d="M240 0h48v16h-48V0Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M288 0h.31v-.31H288V0Zm0 16v.31h.31V16H288ZM240 0v.31h48v-.62h-48V0Zm48 0h-.31v16h.62V0H288Zm0 16v-.31h-48v.62h48V16Z"
        mask="url(#researchRepository-I)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M247.54 6.2a1.22 1.22 0 0 1 1.73 1.73l-.7.7-.33-.33.7-.7a.76.76 0 0 0-1.07-1.07l-.7.7-.33-.33.7-.7Zm.95 1.1-1.71 1.72-.33-.33 1.7-1.71.34.33Zm-2.82.77.7-.7.33.33-.7.7a.76.76 0 0 0 1.07 1.07l.7-.7.33.33-.7.7a1.22 1.22 0 0 1-1.73-1.73Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={252.45} y={9.55}>
          {formatMessage(researchRepositoryMessages['research-repository.field-6-name'])}
        </tspan>
      </text>
      <mask id="researchRepository-J" fill={templateStyles['background']}>
        <path d="M240 16h48v18.67h-48V16Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M288 34.67v.3h.31v-.3H288ZM287.69 16v18.67h.62V16h-.62Zm.31 18.36h-48v.62h48v-.62Z"
        mask="url(#researchRepository-J)"
      />
      <g clipPath="url(#researchRepository-K)">
        <rect
          width={40.53}
          height={6.22}
          x={243.73}
          y={18.49}
          fill={templateStyles['background']}
          rx={0.93}
        />
        <g clipPath="url(#researchRepository-L)">
          <path fill={templateStyles['background']} d="M244.67 19.42h4.36v4.36h-4.36z" />
          <path
            fill={templateStyles['link']}
            d="M246.25 21.5c-.05-.04-.12-.04-.14.02l-.7 1.41-.02.04a.08.08 0 0 0 .09.08h.98l.04-.01c.02 0 .03-.02.03-.04.22-.43.09-1.1-.28-1.5Zm.51-1.28c-.4.63-.36 1.32-.1 1.84l.47.95c.01.02.04.04.07.04h1.03l.03-.04a.08.08 0 0 0 0-.08l-1.35-2.7c-.03-.07-.1-.07-.15 0Z"
          />
        </g>
        <path
          fill={templateStyles['link']}
          d="M250.35 23.49v-3.07h.38v1.33h1.68v-1.33h.39v3.07h-.39v-1.4h-1.68v1.4h-.38Zm4.13.04c-.22 0-.41-.05-.57-.14a.97.97 0 0 1-.37-.41 1.45 1.45 0 0 1-.12-.64c0-.24.04-.46.13-.63a.96.96 0 0 1 .92-.55c.22 0 .41.04.57.14.16.1.28.23.36.4.09.18.13.4.13.64 0 .25-.04.46-.13.64a.95.95 0 0 1-.93.55Zm0-.33c.14 0 .26-.03.36-.1.1-.07.18-.17.23-.3.06-.12.08-.28.08-.46s-.02-.34-.08-.46a.62.62 0 0 0-.23-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.36.1.63.63 0 0 0-.24.3c-.05.12-.07.28-.07.46s.02.34.07.47c.06.12.14.22.24.29.1.07.22.1.36.1Zm1.98.29-.64-2.3h.37l.45 1.84h.04l.5-1.83h.36l.51 1.83h.04l.45-1.83h.36l-.64 2.29h-.37l-.51-1.77h-.04l-.5 1.77h-.38Zm4.97.02c-.23 0-.4-.05-.5-.15-.11-.1-.17-.25-.17-.47V21.5h-.36v-.3h.36v-.6h.39v.6h.5v.3h-.5v1.3c0 .13.02.23.07.3.05.05.14.08.26.08a1.38 1.38 0 0 0 .17-.01v.31a2.57 2.57 0 0 1-.22.03Zm1.68.02c-.21 0-.4-.05-.56-.14a.97.97 0 0 1-.37-.41 1.45 1.45 0 0 1-.12-.64c0-.24.04-.46.12-.63a.96.96 0 0 1 .93-.55c.22 0 .41.04.57.14.15.1.28.23.36.4.09.18.13.4.13.64 0 .25-.04.46-.13.64a.95.95 0 0 1-.93.55Zm0-.33c.15 0 .27-.03.37-.1.1-.07.18-.17.23-.3.06-.12.08-.28.08-.46s-.03-.34-.08-.46a.62.62 0 0 0-.23-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.36.1.63.63 0 0 0-.24.3 1.2 1.2 0 0 0-.07.46c0 .18.02.34.07.47.06.12.13.22.24.29.1.07.22.1.36.1Zm3.63.33a.89.89 0 0 1-.44-.1.63.63 0 0 1-.26-.29 1.11 1.11 0 0 1-.1-.46V21.2h.38v1.4c0 .2.04.35.12.45.08.1.21.15.4.15.1 0 .18-.01.26-.04a.53.53 0 0 0 .2-.13c.05-.06.09-.13.11-.2a.86.86 0 0 0 .04-.28V21.2h.37v2.29h-.37v-.34h-.03a.63.63 0 0 1-.15.2.65.65 0 0 1-.23.13.92.92 0 0 1-.3.05Zm2.56 0c-.17 0-.32-.03-.45-.08a.79.79 0 0 1-.31-.22.62.62 0 0 1-.14-.33h.38c.03.1.09.18.18.23.09.06.2.1.35.1.1 0 .2-.02.27-.05a.46.46 0 0 0 .2-.13.28.28 0 0 0 .06-.18.25.25 0 0 0-.1-.2.72.72 0 0 0-.3-.14l-.36-.09a1.31 1.31 0 0 1-.35-.13.55.55 0 0 1-.2-.2.59.59 0 0 1-.07-.28c0-.13.04-.25.11-.35.08-.1.18-.18.3-.24.14-.06.28-.08.44-.08.17 0 .3.02.43.07s.22.12.3.22c.08.09.12.2.14.32h-.36a.37.37 0 0 0-.17-.22.6.6 0 0 0-.34-.09c-.09 0-.17.02-.24.05a.4.4 0 0 0-.17.12.27.27 0 0 0-.06.18c0 .05.01.1.04.14.03.04.07.07.13.1.05.03.13.06.22.08l.35.09c.21.05.38.12.48.22.1.1.16.23.16.4 0 .13-.04.25-.12.36a.8.8 0 0 1-.33.24c-.14.06-.3.09-.47.09Zm2.43 0c-.22 0-.4-.05-.56-.15a.96.96 0 0 1-.37-.4 1.45 1.45 0 0 1-.12-.63c0-.24.04-.45.12-.62a1 1 0 0 1 .36-.42c.16-.1.34-.15.55-.15.2 0 .38.04.53.14.15.1.27.23.35.4.08.18.12.38.12.6v.15h-1.84v-.3h1.65l-.19.27v-.14c0-.18-.02-.33-.08-.45a.57.57 0 0 0-.55-.34.61.61 0 0 0-.33.09.61.61 0 0 0-.23.26.99.99 0 0 0-.08.44v.14c0 .17.02.3.08.42a.62.62 0 0 0 .6.36c.1 0 .2-.01.27-.04a.6.6 0 0 0 .19-.11.4.4 0 0 0 .1-.14l.01-.01h.37v.01a.69.69 0 0 1-.11.23.86.86 0 0 1-.48.34c-.1.03-.23.05-.36.05Zm3.83.03c-.23 0-.42-.04-.59-.1a1 1 0 0 1-.4-.3.85.85 0 0 1-.16-.45v-.03h.38v.03c.01.1.05.19.12.26.07.08.16.14.27.18a1.18 1.18 0 0 0 .77 0c.11-.05.2-.12.26-.2.06-.07.1-.17.1-.27a.42.42 0 0 0-.15-.32.97.97 0 0 0-.46-.2l-.34-.08c-.3-.07-.53-.17-.67-.31a.76.76 0 0 1-.2-.55.8.8 0 0 1 .13-.46c.1-.13.22-.23.38-.3.17-.08.35-.11.56-.11.2 0 .39.03.55.1.15.08.28.18.37.3.1.13.14.26.15.42v.03h-.38v-.03a.48.48 0 0 0-.11-.24.61.61 0 0 0-.24-.17.89.89 0 0 0-.35-.06.94.94 0 0 0-.34.06c-.1.04-.19.1-.25.17a.42.42 0 0 0-.09.27c0 .13.05.23.14.32.1.08.24.14.45.19l.34.08c.21.04.39.1.52.18.13.07.22.17.28.27a.86.86 0 0 1-.44 1.2c-.17.08-.37.12-.6.12Zm2.5-.03a.89.89 0 0 1-.44-.1.64.64 0 0 1-.27-.29 1.11 1.11 0 0 1-.09-.46V21.2h.37v1.4c0 .2.04.35.12.45.08.1.21.15.4.15.1 0 .19-.01.26-.04a.52.52 0 0 0 .2-.13c.05-.06.09-.13.12-.2a.86.86 0 0 0 .04-.28V21.2h.37v2.29h-.37v-.34h-.04a.62.62 0 0 1-.38.33.93.93 0 0 1-.3.05Zm1.77-.04v-2.3h.37v.35h.03a.54.54 0 0 1 .22-.28c.11-.07.24-.1.4-.1h.1l.08.01v.36a1.06 1.06 0 0 0-.23-.02.67.67 0 0 0-.31.07.54.54 0 0 0-.22.2.55.55 0 0 0-.07.29v1.42h-.37Zm1.98.02a.27.27 0 0 1-.2-.08.27.27 0 0 1-.08-.2c0-.07.03-.14.08-.2a.27.27 0 0 1 .2-.07c.08 0 .14.02.2.08.05.05.08.12.08.2 0 .07-.03.13-.08.19a.26.26 0 0 1-.2.08Zm1.1 0a.27.27 0 0 1-.19-.08.27.27 0 0 1-.08-.2c0-.07.03-.14.08-.2a.27.27 0 0 1 .2-.07c.07 0 .14.02.2.08.05.05.07.12.07.2 0 .07-.02.13-.08.19a.27.27 0 0 1-.2.08Zm1.11 0a.27.27 0 0 1-.2-.08.27.27 0 0 1-.07-.2c0-.07.02-.14.08-.2a.27.27 0 0 1 .2-.07c.07 0 .13.02.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.19a.27.27 0 0 1-.2.08Z"
        />
      </g>
      <rect
        width={40.53}
        height={6.22}
        x={243.73}
        y={18.49}
        stroke={templateStyles['border']}
        strokeWidth={0.31}
        rx={0.93}
      />
      <mask id="researchRepository-M" fill={templateStyles['background']}>
        <path d="M240 34.67h48v18.66h-48V34.67Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M288 53.33v.31h.31v-.3H288Zm-.31-18.66v18.66h.62V34.67h-.62Zm.31 18.35h-48v.62h48v-.62Z"
        mask="url(#researchRepository-M)"
      />
      <g clipPath="url(#researchRepository-N)">
        <rect
          width={40.53}
          height={6.22}
          x={243.73}
          y={37.16}
          fill={templateStyles['background']}
          rx={0.93}
        />
        <g clipPath="url(#researchRepository-O)">
          <path fill={templateStyles['background']} d="M244.67 38.09h4.36v4.36h-4.36z" />
          <path
            fill={templateStyles['link']}
            d="M246.25 40.17c-.05-.04-.12-.04-.14.02l-.7 1.4-.02.05a.08.08 0 0 0 .09.08h.98l.04-.01c.02-.01.03-.02.03-.04.22-.44.09-1.1-.28-1.5Zm.51-1.28c-.4.62-.36 1.32-.1 1.84l.47.94c.01.03.04.05.07.05h.99l.04-.01.03-.03.01-.04v-.04l-1.36-2.71c-.03-.06-.1-.06-.15 0Z"
          />
        </g>
        <path
          fill={templateStyles['link']}
          d="M250.54 42.16v-.34h.95c.23 0 .4-.05.52-.14.12-.1.18-.23.18-.4a.5.5 0 0 0-.08-.3.5.5 0 0 0-.25-.18 1.2 1.2 0 0 0-.4-.06h-.92v-.33h.8a.9.9 0 0 0 .53-.12c.11-.09.17-.2.17-.37a.43.43 0 0 0-.16-.37.68.68 0 0 0-.44-.13h-.9v-.33h.98c.19 0 .35.03.49.09a.7.7 0 0 1 .42.67.7.7 0 0 1-.26.54.59.59 0 0 1-.27.12v.04c.14.01.26.06.36.12.1.07.18.16.24.26s.08.23.08.36c0 .19-.04.34-.12.47a.8.8 0 0 1-.36.3c-.15.06-.34.1-.56.1h-1Zm-.2 0v-3.07h.39v3.07h-.38Zm2.82 0v-2.3h.37v.34h.04a.54.54 0 0 1 .22-.28.82.82 0 0 1 .5-.1l.07.02v.36a1.1 1.1 0 0 0-.22-.02.68.68 0 0 0-.32.07.54.54 0 0 0-.21.2.55.55 0 0 0-.08.28v1.43h-.37Zm2.3.04a.9.9 0 0 1-.4-.09.67.67 0 0 1-.28-.23.65.65 0 0 1-.1-.36.6.6 0 0 1 .1-.36c.07-.1.16-.17.29-.23.12-.05.27-.09.45-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.12.27c0 .12.05.21.14.28.08.06.2.1.33.1.12 0 .24-.03.33-.08a.6.6 0 0 0 .23-.2.52.52 0 0 0 .09-.3v-.71c0-.15-.05-.25-.13-.33-.09-.07-.22-.11-.39-.11a.68.68 0 0 0-.33.07.36.36 0 0 0-.18.21h-.37a.61.61 0 0 1 .15-.32.8.8 0 0 1 .31-.21c.13-.05.27-.08.44-.08.18 0 .34.03.47.1.13.05.23.14.3.26.06.11.1.25.1.4v1.58h-.37v-.34h-.04a.78.78 0 0 1-.4.33.91.91 0 0 1-.29.05Zm1.77-.04v-2.3h.37v2.3h-.37Zm.19-2.74a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18c0-.08.02-.14.07-.19a.25.25 0 0 1 .18-.07c.07 0 .13.03.18.07.05.05.08.11.08.19 0 .06-.03.13-.08.18a.25.25 0 0 1-.18.07Zm.88 2.74v-2.3h.37v.35h.03a.65.65 0 0 1 .26-.29c.1-.06.24-.1.41-.1.26 0 .46.08.6.22.13.15.2.36.2.63v1.49h-.37v-1.4c0-.2-.04-.36-.13-.46-.08-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.36h-.37Zm3.92 0v-2h-.38v-.3h.38v-.25c0-.16.03-.28.08-.38.05-.1.12-.18.22-.22.1-.05.22-.08.37-.08a1.2 1.2 0 0 1 .25.02v.3l-.08-.01a2 2 0 0 0-.1 0c-.13 0-.22.03-.28.1-.06.06-.09.15-.09.28v.24h.52v.3h-.52v2h-.37Zm1.43 0v-2.3h.37v.34h.03a.54.54 0 0 1 .22-.28.83.83 0 0 1 .5-.1l.08.02v.36a1.07 1.07 0 0 0-.23-.02.67.67 0 0 0-.31.07.54.54 0 0 0-.22.2.55.55 0 0 0-.07.28v1.43h-.37Zm1.67 0v-2.3h.37v2.3h-.38Zm.18-2.74a.25.25 0 0 1-.25-.26c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.07c.07 0 .13.03.18.07.05.05.08.11.08.19a.25.25 0 0 1-.26.25Zm1.82 2.78c-.22 0-.4-.05-.56-.15a.96.96 0 0 1-.37-.4 1.45 1.45 0 0 1-.12-.63c0-.24.04-.45.12-.63a1 1 0 0 1 .36-.42c.16-.1.34-.15.55-.15a.92.92 0 0 1 .88.55c.08.17.12.37.12.6v.15h-1.84v-.3h1.65l-.19.27v-.15c0-.18-.02-.32-.08-.44a.56.56 0 0 0-.22-.26.61.61 0 0 0-.33-.09.61.61 0 0 0-.33.1.62.62 0 0 0-.23.26.99.99 0 0 0-.08.43v.15c0 .16.02.3.08.42a.61.61 0 0 0 .6.36c.1 0 .19-.02.27-.05a.6.6 0 0 0 .19-.1.4.4 0 0 0 .1-.14v-.02h.38v.02a.71.71 0 0 1-.11.23.84.84 0 0 1-.2.2 1 1 0 0 1-.28.13c-.1.04-.23.06-.36.06Zm1.55-.04v-2.3h.37v.35h.03a.65.65 0 0 1 .26-.29c.1-.06.24-.1.41-.1.26 0 .46.08.6.22.13.15.2.36.2.63v1.49h-.37v-1.4c0-.2-.04-.36-.13-.46-.08-.1-.22-.15-.4-.15a.62.62 0 0 0-.32.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.36h-.37Zm3.4.04a.88.88 0 0 1-.85-.56 1.52 1.52 0 0 1-.12-.63c0-.24.04-.45.12-.63a.96.96 0 0 1 .33-.41c.15-.1.32-.15.51-.15a.84.84 0 0 1 .55.2c.07.05.12.12.17.2h.03v-1.27h.37v3.2H273v-.36h-.03a.77.77 0 0 1-.72.4Zm.08-.33c.13 0 .25-.04.35-.1.1-.08.18-.17.24-.3.05-.13.08-.28.08-.46s-.03-.33-.08-.46a.66.66 0 0 0-.24-.3.61.61 0 0 0-.35-.1.62.62 0 0 0-.36.1.65.65 0 0 0-.23.3 1.2 1.2 0 0 0-.08.46c0 .18.02.33.08.46.05.13.13.23.23.3.1.06.22.1.36.1Zm1.76.29v-3.2h.37v3.2h-.37Zm1.28.8a.88.88 0 0 1-.17-.01v-.3h.16c.1 0 .19-.02.25-.08a.56.56 0 0 0 .17-.28l.04-.13-.85-2.3h.4l.7 2.12-.14-.23h.17l-.15.23.7-2.12h.4l-.9 2.44c-.06.17-.13.3-.2.4a.56.56 0 0 1-.24.2c-.1.04-.2.06-.34.06Zm4.33-.76a.98.98 0 0 1-.92-.56 1.44 1.44 0 0 1-.13-.64c0-.24.04-.45.12-.62a.97.97 0 0 1 .93-.56c.18 0 .34.04.48.1a.86.86 0 0 1 .48.63v.01h-.37a.53.53 0 0 0-.2-.3.62.62 0 0 0-.4-.11.61.61 0 0 0-.58.4c-.06.13-.08.28-.08.45 0 .18.02.33.08.46a.6.6 0 0 0 .59.4c.15 0 .28-.02.38-.1.1-.06.16-.16.2-.28l.01-.02h.37v.03a.98.98 0 0 1-.17.36.8.8 0 0 1-.32.25c-.13.07-.29.1-.47.1Zm1.8-.02a.27.27 0 0 1-.2-.08.27.27 0 0 1-.08-.2c0-.08.03-.14.08-.2a.27.27 0 0 1 .2-.08c.08 0 .14.03.2.08.05.06.08.12.08.2 0 .08-.03.14-.08.2a.27.27 0 0 1-.2.08Zm1.1 0a.27.27 0 0 1-.19-.08.27.27 0 0 1-.08-.2c0-.08.03-.14.08-.2a.27.27 0 0 1 .2-.08c.07 0 .14.03.2.08.05.06.07.12.07.2 0 .08-.02.14-.08.2a.27.27 0 0 1-.2.08Zm1.11 0a.27.27 0 0 1-.2-.08.27.27 0 0 1-.07-.2c0-.08.02-.14.08-.2a.27.27 0 0 1 .2-.08c.07 0 .13.03.19.08.05.06.08.12.08.2 0 .08-.03.14-.08.2a.27.27 0 0 1-.2.08Z"
        />
      </g>
      <rect
        width={40.53}
        height={6.22}
        x={243.73}
        y={37.16}
        stroke={templateStyles['border']}
        strokeWidth={0.31}
        rx={0.93}
      />
      <mask id="researchRepository-P" fill={templateStyles['background']}>
        <path d="M240 53.33h48v31.11h-48v-31.1Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M288 84.44v.32h.31v-.32H288Zm-.31-31.1v31.1h.62v-31.1h-.62Zm.31 30.8h-48v.62h48v-.63Z"
        mask="url(#researchRepository-P)"
      />
      <g clipPath="url(#researchRepository-Q)">
        <rect
          width={40.53}
          height={6.22}
          x={243.73}
          y={55.82}
          fill={templateStyles['background']}
          rx={0.93}
        />
        <path fill={templateStyles['background']} d="M244.67 56.76h4.36v4.36h-4.36z" />
        {/* <path
          fill={templateStyles['link']}
          d="M246.25 58.84c-.05-.05-.12-.05-.14.01l-.7 1.41-.02.05a.08.08 0 0 0 .09.08h.98c.01 0 .03 0 .04-.02.02 0 .03-.02.03-.03.22-.44.09-1.1-.28-1.5Zm.51-1.28c-.4.62-.36 1.31-.1 1.83l.47.95c.01.03.04.05.07.05h.99l.04-.01.03-.03.01-.04v-.05l-1.36-2.7c-.03-.06-.1-.07-.15 0Z"
        /> */}
        {/* <text
          xmlSpace="preserve"
          fill={templateStyles['link']}
          fontFamily="SF Pro"
          fontSize={4.36}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre',
          }}
        >
          <tspan x={249.96} y={60.48}>
            <a>{'Contextual Inqu'}</a>
          </tspan>
        </text> */}
        <path
          fill={templateStyles['link']}
          d="M246.25 58.84c-.05-.05-.12-.05-.14.01l-.7 1.41-.02.05a.08.08 0 0 0 .09.08h.98c.01 0 .03 0 .04-.02.02 0 .03-.02.03-.03.22-.44.09-1.1-.28-1.5Zm.51-1.28c-.4.62-.36 1.31-.1 1.83l.47.95c.01.03.04.05.07.05h.99l.04-.01.03-.03.01-.04v-.05l-1.36-2.7c-.03-.06-.1-.07-.15 0ZM251.58 60.9a1.3 1.3 0 0 1-.72-.2c-.2-.13-.36-.32-.47-.56-.1-.24-.16-.52-.16-.85 0-.33.05-.62.16-.86s.27-.42.47-.55c.2-.13.44-.2.72-.2.22 0 .41.04.59.13a1.16 1.16 0 0 1 .65.87h-.38a.84.84 0 0 0-.86-.65c-.2 0-.37.06-.51.16a.98.98 0 0 0-.33.43c-.08.19-.12.41-.12.67 0 .26.04.48.12.66.08.2.19.34.33.44.15.1.31.15.51.15.15 0 .27-.02.4-.07a.8.8 0 0 0 .28-.2.7.7 0 0 0 .17-.3h.4a1.05 1.05 0 0 1-.66.81c-.17.08-.37.11-.59.11Zm2.78-.04c-.22 0-.4-.04-.56-.14a.96.96 0 0 1-.37-.41 1.45 1.45 0 0 1-.13-.63c0-.25.05-.46.13-.64.09-.18.2-.31.37-.4.16-.1.34-.15.56-.15.22 0 .4.05.56.14.16.1.28.23.37.41.08.18.13.39.13.63 0 .25-.05.46-.13.64a.95.95 0 0 1-.93.55Zm0-.32c.14 0 .27-.04.37-.1.1-.07.18-.17.23-.3.05-.13.08-.28.08-.46 0-.19-.03-.34-.08-.47a.62.62 0 0 0-.23-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3c-.05.13-.08.28-.08.46 0 .19.03.34.08.47.05.13.13.23.23.3.1.06.22.1.37.1Zm1.63.28v-2.29h.37v.34h.03a.65.65 0 0 1 .26-.28c.1-.07.24-.1.41-.1.26 0 .46.07.6.22.13.15.2.36.2.63v1.48h-.37v-1.4c0-.2-.04-.35-.13-.45-.08-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.2.22.76.76 0 0 0-.08.35v1.35H256Zm3.36.02c-.24 0-.4-.05-.51-.14-.1-.1-.16-.25-.16-.47v-1.4h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.03.23.08.3.05.05.13.08.25.08a1.38 1.38 0 0 0 .17 0v.3a2.97 2.97 0 0 1-.21.03Zm1.67.02c-.21 0-.4-.05-.56-.14a.96.96 0 0 1-.36-.41 1.45 1.45 0 0 1-.13-.63c0-.23.04-.44.13-.62a1 1 0 0 1 .36-.42c.15-.1.33-.15.54-.15.2 0 .39.05.54.14.15.1.26.23.34.4.08.18.12.38.12.6v.15h-1.84v-.3h1.65l-.18.28v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.55-.35.61.61 0 0 0-.33.09.61.61 0 0 0-.23.27.99.99 0 0 0-.09.43v.15c0 .16.03.3.08.42a.62.62 0 0 0 .6.35c.1 0 .2-.01.27-.04a.6.6 0 0 0 .2-.1.4.4 0 0 0 .1-.14v-.02h.37v.02a.69.69 0 0 1-.1.22.86.86 0 0 1-.48.34c-.11.04-.23.05-.37.05Zm1.29-.04.78-1.14-.8-1.15h.44l.55.85h.03l.54-.85h.42l-.78 1.13.79 1.16h-.44l-.54-.86h-.03l-.55.86h-.41Zm3.28.02c-.24 0-.4-.05-.51-.14-.1-.1-.16-.25-.16-.47v-1.4h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.03.23.08.3.05.05.13.08.25.08a1.4 1.4 0 0 0 .17 0v.3a3.33 3.33 0 0 1-.21.03Zm1.54.02a.89.89 0 0 1-.44-.1.63.63 0 0 1-.27-.28 1.11 1.11 0 0 1-.08-.47v-1.48h.37v1.4c0 .2.04.35.12.45.08.1.2.16.39.16.1 0 .19-.02.27-.05a.53.53 0 0 0 .2-.13c.04-.05.08-.12.1-.2a.86.86 0 0 0 .05-.27v-1.36h.37v2.3h-.37v-.35h-.03a.63.63 0 0 1-.16.2.65.65 0 0 1-.22.14.94.94 0 0 1-.3.04Zm2.4 0a.9.9 0 0 1-.4-.08.67.67 0 0 1-.27-.24.65.65 0 0 1-.1-.36c0-.14.04-.25.1-.35.07-.1.16-.18.29-.23.12-.06.27-.09.45-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.12.27c0 .12.05.21.13.28.1.06.2.1.34.1.12 0 .24-.03.33-.08a.6.6 0 0 0 .23-.2.52.52 0 0 0 .09-.3v-.72c0-.14-.05-.25-.13-.32-.09-.08-.22-.11-.39-.11a.68.68 0 0 0-.34.07.36.36 0 0 0-.17.2v.01h-.37a.61.61 0 0 1 .15-.32.8.8 0 0 1 .3-.21c.14-.06.28-.08.44-.08.2 0 .35.03.48.1.13.05.23.14.3.25.06.12.1.25.1.41v1.57h-.37v-.34h-.04a.78.78 0 0 1-.4.34.92.92 0 0 1-.29.04Zm1.8-.04v-3.2h.37v3.2h-.38Zm2.35 0v-3.07h.38v3.07h-.38Zm1.12 0v-2.29h.37v.34h.03a.65.65 0 0 1 .25-.28c.11-.07.25-.1.42-.1.26 0 .45.07.6.22.13.15.2.36.2.63v1.48h-.37v-1.4c0-.2-.05-.35-.13-.45-.09-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.21.22.77.77 0 0 0-.07.35v1.35h-.37Zm4.14.77v-1.11h-.04a.64.64 0 0 1-.16.2.79.79 0 0 1-.25.14.98.98 0 0 1-.81-.1.95.95 0 0 1-.34-.42 1.52 1.52 0 0 1-.11-.62c0-.25.03-.45.11-.63s.2-.32.34-.41c.14-.1.31-.15.5-.15a.82.82 0 0 1 .73.42h.03v-.38h.37v3.06h-.37Zm-.67-1.05a.61.61 0 0 0 .6-.4c.05-.14.08-.29.08-.46 0-.18-.03-.33-.08-.46a.61.61 0 0 0-.6-.4.61.61 0 0 0-.59.4 1.2 1.2 0 0 0-.08.45c0 .19.03.34.08.47.06.13.13.22.23.3.1.06.22.1.36.1Zm2.03.3a.27.27 0 0 1-.2-.08.27.27 0 0 1-.08-.2c0-.07.03-.13.08-.19a.27.27 0 0 1 .2-.08c.07 0 .14.03.2.08.05.06.07.12.07.2 0 .07-.02.14-.08.2a.27.27 0 0 1-.2.07Zm1.1 0a.27.27 0 0 1-.2-.08.27.27 0 0 1-.07-.2c0-.07.02-.13.08-.19a.27.27 0 0 1 .2-.08c.07 0 .13.03.19.08.05.06.08.12.08.2 0 .07-.03.14-.08.2a.27.27 0 0 1-.2.07Zm1.1 0a.27.27 0 0 1-.19-.08.27.27 0 0 1-.08-.2c0-.07.03-.13.08-.19a.27.27 0 0 1 .2-.08c.07 0 .14.03.2.08.05.06.07.12.07.2 0 .07-.02.14-.08.2a.27.27 0 0 1-.2.07Z"
        />
      </g>
      <rect
        width={40.53}
        height={6.22}
        x={243.73}
        y={55.82}
        stroke={templateStyles['border']}
        strokeWidth={0.31}
        rx={0.93}
      />
      <mask id="researchRepository-R" fill={templateStyles['background']}>
        <path d="M240 84.44h48v24.9h-48v-24.9Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M288 109.33v.31h.31v-.3H288Zm-.31-24.89v24.9h.62v-24.9h-.62Zm.31 24.58h-48v.62h48v-.62Z"
        mask="url(#researchRepository-R)"
      />
      <g clipPath="url(#researchRepository-S)">
        <rect
          width={40.53}
          height={6.22}
          x={243.73}
          y={86.93}
          fill={templateStyles['background']}
          rx={0.93}
        />
        <path fill={templateStyles['background']} d="M244.67 87.87h4.36v4.36h-4.36z" />
        <path
          fill={templateStyles['link']}
          d="M246.25 89.95c-.05-.05-.12-.04-.14.02l-.7 1.4-.02.05a.08.08 0 0 0 .09.08h.98c.01 0 .03 0 .04-.02.02 0 .03-.02.03-.03.22-.44.09-1.1-.28-1.5Zm.51-1.28c-.4.62-.36 1.31-.1 1.83l.47.95c.01.03.04.05.07.05h.99l.04-.01.03-.03.01-.04v-.04l-1.36-2.71c-.03-.06-.1-.06-.15 0ZM250.35 91.93v-3.07h.38v1.33h1.68v-1.33h.39v3.07h-.39v-1.4h-1.68v1.4h-.38Zm4.13.04c-.22 0-.41-.04-.57-.14a.97.97 0 0 1-.37-.4 1.45 1.45 0 0 1-.12-.64c0-.25.04-.46.13-.64a.96.96 0 0 1 .92-.55c.22 0 .41.05.57.14.16.1.28.23.36.41.09.18.13.39.13.63 0 .25-.04.46-.13.64a.95.95 0 0 1-.93.55Zm0-.32c.14 0 .26-.04.36-.1.1-.07.18-.17.23-.3.06-.13.08-.28.08-.46 0-.19-.02-.34-.08-.47a.62.62 0 0 0-.23-.29.64.64 0 0 0-.37-.1.64.64 0 0 0-.36.1.63.63 0 0 0-.24.3c-.05.12-.07.27-.07.45 0 .19.02.34.07.47.06.13.14.23.24.3.1.06.22.1.36.1Zm1.98.28-.64-2.29h.37l.45 1.83h.04l.5-1.83h.36l.51 1.83h.04l.45-1.83h.36l-.64 2.3h-.37l-.51-1.78h-.04l-.5 1.77h-.38Zm5 0v-2.72h-.99v-.35h2.36v.35h-.98v2.72h-.39Zm2.44.04c-.22 0-.4-.04-.57-.14a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.64c0-.25.04-.46.13-.64.08-.18.2-.31.36-.4.16-.1.35-.15.57-.15.22 0 .4.05.56.14.16.1.28.23.36.41.09.18.13.39.13.63 0 .25-.04.46-.13.64a.96.96 0 0 1-.36.41c-.16.1-.34.14-.56.14Zm0-.32c.14 0 .26-.04.36-.1.1-.07.18-.17.23-.3.06-.13.08-.28.08-.46 0-.19-.02-.34-.08-.47a.62.62 0 0 0-.23-.29.64.64 0 0 0-.36-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3 1.2 1.2 0 0 0-.08.45c0 .19.02.34.08.47.05.13.13.23.23.3.1.06.22.1.37.1Zm2.9.28v-3.07h1.05c.3 0 .56.07.78.19.22.12.38.3.5.52.11.23.17.5.17.83 0 .32-.06.6-.17.83-.12.23-.28.4-.5.52-.21.12-.47.18-.78.18h-1.05Zm.38-.34h.65c.23 0 .42-.05.58-.14a.9.9 0 0 0 .37-.4c.09-.19.13-.4.13-.65s-.04-.46-.13-.64a.9.9 0 0 0-.37-.4c-.16-.1-.36-.15-.58-.15h-.65v2.38Zm3.68.38a.96.96 0 0 1-.93-.55 1.45 1.45 0 0 1-.13-.63c0-.25.05-.46.13-.64.09-.18.2-.31.37-.4.15-.1.34-.15.56-.15.22 0 .4.05.56.14.16.1.28.23.37.41.08.18.13.39.13.63 0 .25-.05.46-.13.64a.95.95 0 0 1-.93.55Zm0-.32c.14 0 .27-.04.37-.1.1-.07.17-.17.23-.3.05-.13.08-.28.08-.46 0-.19-.03-.34-.08-.47a.62.62 0 0 0-.23-.29.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.64.64 0 0 0-.23.3c-.05.12-.08.27-.08.45 0 .19.03.34.08.47.05.13.13.23.23.3.1.06.22.1.37.1Zm3.49.32a.9.9 0 0 1-.4-.08.67.67 0 0 1-.27-.24.65.65 0 0 1-.1-.36c0-.14.03-.25.1-.35.06-.1.16-.17.28-.23.13-.05.28-.09.46-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.12.27c0 .12.04.21.13.28.09.06.2.1.33.1s.24-.03.34-.08a.6.6 0 0 0 .23-.2.52.52 0 0 0 .08-.3v-.72c0-.14-.04-.25-.13-.32-.08-.07-.21-.11-.38-.11a.68.68 0 0 0-.34.07.36.36 0 0 0-.18.2v.01h-.37a.61.61 0 0 1 .15-.32.8.8 0 0 1 .31-.21c.13-.05.28-.08.44-.08.19 0 .35.03.48.1.13.05.22.14.29.26.07.1.1.25.1.4v1.57h-.37v-.33h-.03a.78.78 0 0 1-.41.33.91.91 0 0 1-.28.04Zm4.28.04a1.3 1.3 0 0 1-.73-.2c-.2-.13-.35-.32-.46-.56-.11-.23-.17-.52-.17-.85 0-.33.06-.62.17-.86.1-.24.26-.42.46-.55.2-.13.45-.2.72-.2.22 0 .42.04.6.13.17.08.31.2.43.35.11.15.19.32.22.52h-.4a.84.84 0 0 0-.85-.64.86.86 0 0 0-.84.58c-.08.19-.11.41-.11.67 0 .26.03.48.11.67.08.18.19.33.33.43a1.06 1.06 0 0 0 .9.09.73.73 0 0 0 .46-.5v-.01h.4a1.06 1.06 0 0 1-.66.81c-.17.08-.37.12-.58.12Zm2.13-.06a.27.27 0 0 1-.2-.08.27.27 0 0 1-.07-.2c0-.07.02-.13.08-.19a.27.27 0 0 1 .2-.08c.07 0 .13.03.19.08.05.06.08.12.08.2 0 .07-.03.14-.08.2a.27.27 0 0 1-.2.07Zm1.1 0a.27.27 0 0 1-.19-.08.27.27 0 0 1-.08-.2c0-.07.03-.13.08-.19a.27.27 0 0 1 .2-.08c.08 0 .14.03.2.08.05.06.08.12.08.2 0 .07-.03.14-.08.2a.27.27 0 0 1-.2.07Zm1.12 0a.27.27 0 0 1-.2-.08.27.27 0 0 1-.08-.2c0-.07.03-.13.08-.19a.27.27 0 0 1 .2-.08c.07 0 .14.03.2.08.05.06.07.12.07.2 0 .07-.02.14-.08.2a.27.27 0 0 1-.2.07Z"
        />
      </g>
      <rect
        width={40.53}
        height={6.22}
        x={243.73}
        y={86.93}
        stroke={templateStyles['border']}
        strokeWidth={0.31}
        rx={0.93}
      />
      <mask id="researchRepository-T" fill={templateStyles['background']}>
        <path d="M240 109.33h48V128h-48v-18.67Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M288 128v.31h.31V128H288Zm-.31-18.67V128h.62v-18.67h-.62Zm.31 18.36h-48v.62h48v-.62Z"
        mask="url(#researchRepository-T)"
      />
      <g clipPath="url(#researchRepository-U)">
        <rect
          width={40.53}
          height={6.22}
          x={243.73}
          y={111.82}
          fill={templateStyles['background']}
          rx={0.93}
        />
        <path fill={templateStyles['background']} d="M244.67 112.76h4.36v4.36h-4.36z" />
        <path
          fill={templateStyles['link']}
          d="M246.25 114.84c-.05-.05-.12-.05-.14.01l-.7 1.41-.02.05.02.04a.09.09 0 0 0 .07.04h.98a.08.08 0 0 0 .07-.05c.22-.44.09-1.1-.28-1.5Zm.51-1.28c-.4.62-.36 1.31-.1 1.83l.47.95c.01.03.04.05.07.05h.99l.04-.01.03-.03.01-.04v-.05l-1.36-2.7c-.03-.06-.1-.06-.15 0ZM250.35 116.82v-3.07h.38v2.73h1.48v.34h-1.86Zm2.43 0v-2.29h.37v2.3h-.37Zm.2-2.73a.25.25 0 0 1-.26-.26c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.07.25.25 0 0 1 .25.25c0 .07-.02.13-.07.18a.25.25 0 0 1-.18.08Zm1.03 2.73v-1.98h-.39v-.31h.38v-.26c0-.15.03-.27.08-.37.05-.1.13-.18.22-.23a.8.8 0 0 1 .37-.07 1.28 1.28 0 0 1 .25.02v.3a.76.76 0 0 0-.17-.02c-.14 0-.23.04-.29.1-.06.06-.09.16-.09.28v.25h.53v.3h-.53v2H254Zm2.26.04c-.22 0-.4-.05-.56-.14a.96.96 0 0 1-.36-.41 1.45 1.45 0 0 1-.13-.63c0-.23.04-.44.13-.62a1 1 0 0 1 .36-.42c.15-.1.33-.15.54-.15.2 0 .39.05.53.14.16.1.27.23.35.4.08.18.12.38.12.6v.15h-1.84v-.3h1.65l-.18.28v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.55-.35.61.61 0 0 0-.34.09.62.62 0 0 0-.22.27 1 1 0 0 0-.09.43v.15c0 .16.03.3.08.42.06.11.14.2.24.26a.77.77 0 0 0 .63.05.6.6 0 0 0 .19-.1.41.41 0 0 0 .1-.14l.01-.02h.37v.02a.7.7 0 0 1-.1.22.83.83 0 0 1-.2.2 1 1 0 0 1-.28.14c-.11.04-.23.05-.37.05Zm3.72 0c-.22 0-.4-.05-.56-.14a.97.97 0 0 1-.37-.41 1.45 1.45 0 0 1-.13-.63c0-.25.05-.46.13-.64a.96.96 0 0 1 .93-.55c.22 0 .4.05.56.14.16.1.28.23.37.41.08.18.13.39.13.63 0 .25-.05.46-.13.64a.94.94 0 0 1-.37.41c-.15.1-.34.14-.56.14Zm0-.33c.15 0 .27-.03.37-.1.1-.07.18-.16.23-.29.05-.13.08-.28.08-.46 0-.19-.03-.34-.08-.47a.61.61 0 0 0-.23-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3c-.05.13-.08.28-.08.46 0 .19.03.34.08.47.06.13.13.22.23.3.1.06.23.1.37.1Zm1.79.3v-2h-.38v-.3h.38v-.26c0-.15.02-.27.07-.37.05-.1.13-.18.23-.23a.8.8 0 0 1 .36-.07 1.27 1.27 0 0 1 .25.02v.3a.73.73 0 0 0-.17-.02c-.14 0-.23.04-.29.1-.06.06-.08.16-.08.28v.25h.52v.3h-.52v2h-.37Zm3.28.03a.9.9 0 0 1-.4-.08.68.68 0 0 1-.27-.24.64.64 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.06-.1.16-.17.28-.23.13-.06.28-.09.46-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.12.27c0 .12.04.21.13.28.09.06.2.1.33.1s.24-.03.34-.08a.6.6 0 0 0 .23-.2.53.53 0 0 0 .08-.3v-.72c0-.14-.04-.25-.13-.32-.08-.08-.21-.11-.38-.11a.69.69 0 0 0-.34.07.36.36 0 0 0-.18.2v.01h-.37a.62.62 0 0 1 .15-.32.8.8 0 0 1 .32-.21c.12-.05.27-.08.43-.08.19 0 .35.03.48.1.13.05.22.14.3.25.06.12.1.25.1.41v1.57h-.38v-.34h-.03a.77.77 0 0 1-.7.38Zm4.31.03c-.21 0-.4-.03-.57-.1a1.24 1.24 0 0 1-.44-.33 1.5 1.5 0 0 1-.28-.5c-.07-.2-.1-.43-.1-.67 0-.33.06-.61.17-.85.12-.24.28-.43.49-.56.2-.13.45-.2.73-.2.23 0 .43.04.6.12a1.16 1.16 0 0 1 .68.85v.02h-.38v-.02a.84.84 0 0 0-.33-.46.99.99 0 0 0-.57-.16.91.91 0 0 0-.87.6 1.86 1.86 0 0 0-.06 1.19c.05.14.12.28.2.38a.9.9 0 0 0 .74.34c.18 0 .34-.04.48-.1a.81.81 0 0 0 .43-.77v-.07h-.86v-.34h1.25v.38c0 .18-.04.36-.1.51a1.13 1.13 0 0 1-.67.66 1.5 1.5 0 0 1-.54.08Zm1.94-.07v-2.29h.37v.34h.03a.54.54 0 0 1 .23-.28c.1-.07.23-.1.38-.1h.1l.09.01v.36a.76.76 0 0 0-.11-.01h-.12a.68.68 0 0 0-.31.06.54.54 0 0 0-.22.2.56.56 0 0 0-.07.3v1.41h-.37Zm2.54.04c-.22 0-.41-.05-.57-.14a.96.96 0 0 1-.36-.41 1.45 1.45 0 0 1-.13-.63c0-.25.04-.46.13-.64.08-.18.2-.31.36-.4.16-.1.35-.15.57-.15.21 0 .4.05.56.14.16.1.28.23.36.41.09.18.13.39.13.63 0 .25-.04.46-.13.64a.95.95 0 0 1-.92.55Zm0-.33c.14 0 .26-.03.36-.1.1-.07.18-.16.23-.29.06-.13.08-.28.08-.46 0-.19-.02-.34-.08-.47a.62.62 0 0 0-.23-.3.64.64 0 0 0-.36-.1.64.64 0 0 0-.37.1.64.64 0 0 0-.24.3c-.05.13-.07.28-.07.46 0 .19.02.34.07.47.06.13.14.22.24.3.1.06.22.1.37.1Zm1.98.3-.64-2.3h.37l.45 1.83h.04l.5-1.83h.36l.51 1.83h.04l.45-1.83h.36l-.64 2.3h-.37l-.51-1.78h-.04l-.5 1.77h-.38Zm3.75 0c-.24 0-.4-.04-.51-.13-.1-.1-.16-.26-.16-.47v-1.4h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.03.23.08.3.05.05.13.08.25.08H279.8v.3a1.97 1.97 0 0 1-.21.03Zm1.07.01a.27.27 0 0 1-.28-.28c0-.07.03-.14.08-.19a.27.27 0 0 1 .2-.08c.08 0 .14.03.2.08.05.05.07.12.07.2a.27.27 0 0 1-.27.27Zm1.1 0a.27.27 0 0 1-.28-.28c0-.07.03-.14.09-.19a.27.27 0 0 1 .2-.08c.07 0 .14.03.19.08.05.05.08.12.08.2a.27.27 0 0 1-.28.27Zm1.11 0a.27.27 0 0 1-.28-.28c0-.07.03-.14.08-.19a.27.27 0 0 1 .2-.08c.08 0 .14.03.2.08.05.05.08.12.08.2a.27.27 0 0 1-.28.27Z"
        />
      </g>
      <rect
        width={40.53}
        height={6.22}
        x={243.73}
        y={111.82}
        stroke={templateStyles['border']}
        strokeWidth={0.31}
        rx={0.93}
      />
      <path
        fill={templateStyles['background']}
        d="M288 0h45a3 3 0 0 1 3 3v125.01h-48V0Z"
      />
      <mask id="researchRepository-V" fill={templateStyles['background']}>
        <path d="M288 0h45a3 3 0 0 1 3 3v13h-48V0Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M288-.31h45A3.31 3.31 0 0 1 336.31 3h-.62c0-1.49-1.2-2.69-2.69-2.69h-45v-.62Zm48.31 16.62H288v-.62h47.69l.62.62ZM288 16V0v16ZM333-.31A3.31 3.31 0 0 1 336.31 3v13.31l-.62-.62V3c0-1.49-1.2-2.69-2.69-2.69v-.62Z"
        mask="url(#researchRepository-V)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M293.29 6.44c0-.34.28-.62.62-.62h3.11c.35 0 .63.28.63.62v3.12c0 .34-.28.62-.63.62h-3.1a.62.62 0 0 1-.63-.62V6.44Zm.62-.15a.16.16 0 0 0-.15.15v3.12c0 .08.07.15.15.15h3.11c.09 0 .16-.07.16-.15V6.44a.16.16 0 0 0-.16-.15h-3.1Zm2.8 1.09h-2.49V6.9h2.5v.47Zm-.62 1.09h-1.87V8h1.87v.47Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={300.45} y={9.55}>
          {formatMessage(researchRepositoryMessages['research-repository.field-7-name'])}
        </tspan>
      </text>
      <mask id="researchRepository-W" fill={templateStyles['background']}>
        <path d="M320 0h13a3 3 0 0 1 3 3v13h-16V0Z" />
      </mask>
      <path fill={templateStyles['background']} d="M320 0h13a3 3 0 0 1 3 3v13h-16V0Z" />
      <path
        fill="#DDE0E5"
        d="M320 0v-.3h-.3V0h.3Zm16 16v.3h.3V16h-.3Zm-16 0h-.3v.3h.3V16Zm0-16v.3h13v-.6h-13V0Zm16 3h-.3v13h.6V3h-.3Zm0 13v-.3h-16v.6h16V16Zm-16 0h.3V0h-.6v16h.3Zm13-16v.3c1.5 0 2.7 1.2 2.7 2.7h.6A3.3 3.3 0 0 0 333-.3V0Z"
        mask="url(#researchRepository-W)"
      />
      <path
        fill={templateStyles['background']}
        fillOpacity={0.01}
        d="M324.27 4.27h7.47v7.47h-7.47z"
      />
      <path
        fill={templateStyles['icon']}
        d="M328 5.51c.16 0 .3.12.3.28l.01.03V7.7h1.87a.31.31 0 0 1 .03.62h-1.9v1.87a.31.31 0 0 1-.62.03V8.31h-1.87a.31.31 0 0 1-.03-.62h1.9V5.82c0-.17.14-.3.31-.3Z"
      />
      <mask id="researchRepository-X" fill={templateStyles['background']}>
        <path d="M288 16h48v18.67h-48V16Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M336 34.67v.31h.31v-.31H336ZM336 16h-.31v18.67h.62V16H336Zm0 18.67v-.31h-48v.62h48v-.31Z"
        mask="url(#researchRepository-X)"
      />
      <mask id="researchRepository-Y" fill={templateStyles['background']}>
        <path d="M288 34.67h48v18.67h-48V34.67Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M336 53.34v.31h.31v-.31H336Zm0-18.67h-.31v18.67h.62V34.67H336Zm0 18.67v-.31h-48v.62h48v-.31Z"
        mask="url(#researchRepository-Y)"
      />
      <mask id="researchRepository-Z" fill={templateStyles['background']}>
        <path d="M288 53.34h48v31.11h-48V53.34Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M336 84.45v.31h.31v-.31H336Zm0-31.11h-.31v31.11h.62V53.34H336Zm0 31.11v-.31h-48v.62h48v-.31Z"
        mask="url(#researchRepository-Z)"
      />
      <mask id="researchRepository-aa" fill={templateStyles['background']}>
        <path d="M288 84.45h48v24.89h-48V84.45Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M336 109.34v.31h.31v-.31H336Zm0-24.89h-.31v24.89h.62V84.45H336Zm0 24.89v-.31h-48v.62h48v-.31Z"
        mask="url(#researchRepository-aa)"
      />
      <mask id="researchRepository-ab" fill={templateStyles['background']}>
        <path d="M288 109.34h48v18.67h-48v-18.67Z" />
      </mask>
      <path
        fill="#DDE0E5"
        d="M336 128.01v.31h.31v-.31H336Zm0-18.67h-.31v18.67h.62v-18.67H336Zm0 18.67v-.31h-48v.62h48v-.31Z"
        mask="url(#researchRepository-ab)"
      />
      <defs>
        <clipPath id="researchRepository-o">
          <path fill={templateStyles['background']} d="M96 16h48v18.67H96V16Z" />
        </clipPath>
        <clipPath id="researchRepository-q">
          <path fill={templateStyles['background']} d="M96 34.67h48v18.66H96V34.67Z" />
        </clipPath>
        <clipPath id="researchRepository-u">
          <path fill={templateStyles['background']} d="M96 109.33h48V128H96v-18.67Z" />
        </clipPath>
        <clipPath id="researchRepository-K">
          <rect
            width={40.53}
            height={6.22}
            x={243.73}
            y={18.49}
            fill={templateStyles['background']}
            rx={0.93}
          />
        </clipPath>
        <clipPath id="researchRepository-L">
          <path fill={templateStyles['background']} d="M244.67 19.42h4.36v4.36h-4.36z" />
        </clipPath>
        <clipPath id="researchRepository-N">
          <rect
            width={40.53}
            height={6.22}
            x={243.73}
            y={37.16}
            fill={templateStyles['background']}
            rx={0.93}
          />
        </clipPath>
        <clipPath id="researchRepository-O">
          <path fill={templateStyles['background']} d="M244.67 38.09h4.36v4.36h-4.36z" />
        </clipPath>
        <clipPath id="researchRepository-Q">
          <rect
            width={40.53}
            height={6.22}
            x={243.73}
            y={55.82}
            fill={templateStyles['background']}
            rx={0.93}
          />
        </clipPath>
        <clipPath id="researchRepository-S">
          <rect
            width={40.53}
            height={6.22}
            x={243.73}
            y={86.93}
            fill={templateStyles['background']}
            rx={0.93}
          />
        </clipPath>
        <clipPath id="researchRepository-U">
          <rect
            width={40.53}
            height={6.22}
            x={243.73}
            y={111.82}
            fill={templateStyles['background']}
            rx={0.93}
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default ResearchRepository;
